(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7119,2426],{

/***/ 55120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27812);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89744);
/* harmony import */ var _BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var BreadCrumb = function BreadCrumb(_ref) {
  var list = _ref.list,
      title = _ref.title,
      replacePageTitle = _ref.replacePageTitle;
  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .componentResize */ .Y4)();
  var itemsBefore = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_before_collapser_mbl */ .Z.BreadCrumbLabels.items_display_before_collapser_mbl;
  var itemsAfter = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.items_display_after_collapser_mbl */ .Z.BreadCrumbLabels.items_display_after_collapser_mbl;
  var breadcrumbList = [];
  var currentPage = {};
  var lastItem;
  var router = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var dispatch = (0,_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useDispatch)();
  var isMiniApp = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getCookieValue */ .Do)("miniApp") === "true";

  var handleClick = function handleClick(url) {
    (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .showSpinner */ .yh)();
    dispatch({
      type: _Redux_actionTypes__WEBPACK_IMPORTED_MODULE_4__/* .BREADCRUMB_SELECT */ .T1,
      payload: true
    });

    if ((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url === "/") {
      if (true) {
        var origin = window.location.origin; // .then(()=>{

        window.location.assign(origin);
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)(); // window.lo
        // })
      }
    } else {
      router.push((0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .internalUrl */ .az)(url).url).then(function () {
        (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .hideSpinner */ .v3)();
      });
    }
  };

  function handleBreadCrumbMobile(breadcrumbList) {
    if (isMobile && breadcrumbList.length > _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.max_display_items_mbl */ .Z.BreadCrumbLabels.max_display_items_mbl) {
      breadcrumbList.splice.apply(breadcrumbList, [0, breadcrumbList.length].concat((0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(0, itemsBefore)), [{
        title: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile */ .Z.BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile
      }], (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(breadcrumbList.slice(breadcrumbList.length - itemsAfter, breadcrumbList.length))));
    }

    lastItem = breadcrumbList.length - 1;
    return breadcrumbList;
  }

  if (list) {
    var totalKeys = Object.keys(list).length; // Mapping current page object into currentPage

    if (totalKeys > 0) {
      currentPage = Object.values(list)[totalKeys - 1];
    }

    Object.entries(list).forEach(function (value) {
      var replacedTitle = title && value[1].url === currentPage.url ? title : null;
      var replacePageTitleBool = replacePageTitle && value[1].url === currentPage.url ? true : false;
      var matchedRoute = {
        url: value[1].url,
        title: value[0],
        replacedTitle: replacedTitle,
        replacePageTitle: replacePageTitleBool
      };
      breadcrumbList.push(matchedRoute);
    });
    lastItem = breadcrumbList.length - 1;
  }

  return isMiniApp || breadcrumbList.length === 0 || breadcrumbList.length === 1 && breadcrumbList[0].url == "/" ? "" : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Nav, {
    className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-wrapper"])),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ol", {
      className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-list"])),
      children: handleBreadCrumbMobile(breadcrumbList).map(function (bcrumb, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
          className: "".concat((_BreadCrumb_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["breadcrumb-item"])),
          id: "".concat(index, "_").concat(bcrumb.title),
          children: lastItem !== index && bcrumb.url ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
            id: "".concat(index, "_").concat(bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title),
            onClick: function onClick() {
              return handleClick(bcrumb.url);
            },
            children: ["                    ", bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title]
          }) : bcrumb.replacePageTitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.replacedTitle),
            children: bcrumb.replacedTitle
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            id: "".concat(index, "_").concat(bcrumb.title),
            children: bcrumb.title
          })
        }, index);
      })
    })
  });
};

BreadCrumb.defaultProps = {
  list: null,
  title: "",
  replacePageTitle: false
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 30698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98033);
/* harmony import */ var _carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var CarouselButton = function CarouselButton(_ref) {
  var prev = _ref.prev,
      next = _ref.next,
      className = _ref.className,
      variant = _ref.variant,
      btnSize = _ref.btnSize,
      btnColor = _ref.btnColor,
      btnTheme = _ref.btnTheme,
      handleClick = _ref.handleClick,
      id = _ref.id;

  var handleButtonClick = function handleButtonClick(e) {
    e.preventDefault();

    if (handleClick) {
      handleClick();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: "".concat(className, " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["owl--" + variant], " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())[btnTheme]),
    children: [next && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "owl--next  ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn), " \n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn--" + btnSize], "\n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["btn--next"])),
      onClick: function onClick(event) {
        return handleButtonClick(event);
      },
      id: id,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn__arrow),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
          className: "v-icon-chevron-right ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["".concat(btnColor)], " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["icon__".concat(btnSize)])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn__".concat(btnSize)]
      })]
    }), prev && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "owl--prev  ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn), " \n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn--" + btnSize], "\n          ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["btn--prev"])),
      onClick: function onClick(event) {
        return handleButtonClick(event);
      },
      id: id,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default().btn__arrow),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
          className: "v-icon-chevron-left ".concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["".concat(btnColor)], " ").concat((_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["icon__".concat(btnSize)])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_carouselButton_module_scss__WEBPACK_IMPORTED_MODULE_1___default())["btn__".concat(btnSize)]
      })]
    })]
  });
};

CarouselButton.defaultProps = {
  className: "",
  variant: "arc",
  btnSize: "bg",
  btnColor: "white",
  btnTheme: "dark"
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselButton);

/***/ }),

/***/ 46005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69152);
/* harmony import */ var _errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34289);
/* harmony import */ var _errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var ErrorPage = function ErrorPage(_ref) {
  var statusCode = _ref.statusCode,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? "This page could not be found." : _ref$message;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .view */ .ei({
      page_name: "".concat(statusCode, " error"),
      page_form_event: "error",
      page_errors: "".concat(statusCode, ". ").concat(message),
      page_error_type: "page",
      page_channel: "shopping"
    });
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().error),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
          className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().code),
          children: statusCode
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
            className: (_errorPage_module_scss__WEBPACK_IMPORTED_MODULE_4___default().message),
            children: message
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorPage);

/***/ }),

/***/ 2458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40001);
/* harmony import */ var _homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69152);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var HomeTabs = function HomeTabs(_ref) {
  var tabsContent = _ref.tabsContent,
      variant = _ref.variant,
      tabType = _ref.tabType,
      alignment = _ref.alignment,
      className = _ref.className,
      analytics = _ref.analytics,
      selectedTab = _ref.selectedTab,
      selectTabHandler = _ref.selectTabHandler,
      page = _ref.page;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(tabsContent.length ? tabsContent[0].title : "unknown"),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var attributes = ["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"];

  var generateVariant = function generateVariant() {
    return variant ? "tabs-design__nav--" + variant : "";
  };

  var generateAlignment = function generateAlignment() {
    switch (alignment) {
      case "left":
      case "LEFT":
        return alignment ? "tabs-design__nav--" + alignment.toLowerCase() : "";
        break;

      case "RIGHT":
      case "right":
        return alignment ? "tabs-design__nav--" + alignment.toLowerCase() : "";
        break;

      default:
        return "tabs-design__nav--";
    }
  };

  var generateTabType = function generateTabType() {
    return tabType ? "tabs-design__nav--" + tabType : "";
  };

  var generateStyle = function generateStyle() {
    var tabStyle = generateTabType();
    var variantStyle = "";

    if (tabType != "button") {
      variantStyle = generateVariant();
    }

    return "".concat(tabStyle, " ").concat(variantStyle);
  };

  var generateTabLine = function generateTabLine() {
    if (generateVariant() === ("tabs-design__nav--black-with-line" || 0)) {
      return true;
    }
  };

  var generatePageSpecificClass = function generatePageSpecificClass() {
    var style = "nav-alignment";

    if (page && page == "upgrade") {
      style = "";
    }

    return style;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (selectedTab && page && page == "upgrade") {
      setActiveTab(selectedTab);
    }
  }, [selectedTab]);

  var handleTabChange = function handleTabChange(eventKey) {
    setActiveTab(eventKey);

    if (page && page == "upgrade") {
      selectTabHandler(eventKey);
    }

    var linkName = analytics.link_name ? "".concat(analytics.link_name, " ").concat(eventKey) : eventKey;
    _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__/* .link */ .p4(_objectSpread({
      link_type: "o",
      page_tool_name: linkName,
      page_tool_event: "use"
    }, _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_3__/* .getUtagData */ .GS(attributes)));
    setTimeout(react_lazyload__WEBPACK_IMPORTED_MODULE_4__/* .forceCheck */ .be, 1000);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: tabsContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Tab.Container, {
      defaultActiveKey: tabsContent[0].title,
      activeKey: activeTab,
      onSelect: handleTabChange,
      mountOnEnter: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["home-tabs-container"]), " "),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Container, {
          className: (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateTabLine() && "underline"],
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Nav, {
            variant: "tabs",
            className: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tabs-design__nav"]), "  ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateVariant()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateTabType()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateAlignment()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generateStyle()], " ").concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[generatePageSpecificClass()]),
            children: tabsContent.map(function (tab, index) {
              var _jsx2;

              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Nav.Item, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Nav.Link, (_jsx2 = {
                  id: tab.title,
                  eventKey: tab.title,
                  bsPrefix: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tab-link"]), " ").concat(activeTab === tab.title ? (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tab-link--active"]) : "", " ").concat(activeTab == "Past usage & spend" || tab.title == "Past usage & spend" ? (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["past-usage-tab"]) : "")
                }, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_jsx2, "id", "".concat(tab.title, "_").concat(index)), (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_jsx2, "children", tab.title), _jsx2))
              }, index);
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: "".concat((_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["tabs-design__content"]), " ").concat(page == "upgrade" ? (_homeTabs_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["upgrade-custom"]) : ""),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Tab.Content, {
            children: tabsContent.map(function (tab, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Tab.Pane, {
                eventKey: tab.title,
                children: tab.component
              }, index);
            })
          })
        })]
      })
    })
  });
};

HomeTabs.defaultProps = {
  tabsContent: [],
  variant: "home",
  analytics: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeTabs);

/***/ }),

/***/ 74010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ upgrade; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/breadCrumb/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(55120);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton_CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./components/molecules/UpgradeFiltersModal/UpgradeFiltersModal.module.scss
var UpgradeFiltersModal_module = __webpack_require__(58043);
var UpgradeFiltersModal_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeFiltersModal_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/UpgradeFiltersModal/UpgradeFiltersModal.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var UpgradeFiltersModal = function UpgradeFiltersModal(props) {
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var _useState = (0,react.useState)(true),
      displayCategory = _useState[0],
      setDisplayCategory = _useState[1];

  var _useState2 = (0,react.useState)(),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      subCatgeory = _useState3[0],
      setSubCategory = _useState3[1];

  var _useState4 = (0,react.useState)(props.selectedBrand),
      selectedBrand = _useState4[0],
      setSelectedBrand = _useState4[1];

  var _useState5 = (0,react.useState)(props.selectedModel),
      selectedModel = _useState5[0],
      setSelectedModel = _useState5[1];

  var _useState6 = (0,react.useState)(),
      selectedSubCategory = _useState6[0],
      setSelectedSubCategory = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isReset = _useState7[0],
      setIsReset = _useState7[1];

  (0,react.useEffect)(function () {
    setSelectedBrand(props.selectedBrand);
  }, [props.selectedBrand]);
  (0,react.useEffect)(function () {
    setSelectedModel(props.selectedModel);
  }, [props.selectedModel]);
  (0,react.useEffect)(function () {
    if (isReset) {
      props.applyFilters();
      setIsReset(false);
    }
  }, [isReset]);

  var handleResetAll = function handleResetAll() {
    props.setSelectedBrand();
    props.setSelectedModel();
    props.setSelectedContractType("");
    setSelectedBrand();
    setSelectedModel();
    setSelectedSubCategory();
    props.setContractTypeFilterApplied(false);
    props.setBrandFilterApplied(false);
    props.setModelFilterApplied(false);
    setIsReset(true);
  };

  var handleCategory = function handleCategory(item) {
    setSelectedCategory(item.name);
    setDisplayCategory(false);

    switch (item.name) {
      case "Brands":
        var sortedBrands = props.brands.sort(function (a, b) {
          return a.localeCompare(b);
        });
        setSubCategory(sortedBrands ? sortedBrands : props.brands);
        break;

      case "Models":
        setSubCategory(props.models);
        break;

      default:
        setSubCategory(props.planData);
        break;
    }
  };

  var handleBackbtn = function handleBackbtn() {
    setDisplayCategory(true);
    setSelectedBrand();
    setSelectedModel();
    setSelectedSubCategory();
  };

  var handleSelections = function handleSelections(item, type) {
    var selArray;

    switch (type == "category" ? item.name : item) {
      case labels/* default.upgrade.planData.lbl_looking_for */.Z.upgrade.planData.lbl_looking_for:
        selArray = props.selectedContractType;
        break;

      case "Brands":
        selArray = selectedBrand ? selectedBrand : props.selectedBrand;
        break;

      case "Models":
        selArray = selectedModel ? selectedModel : props.selectedModel;
        break;

      default:
        selArray = "";
        break;
    }

    return selArray;
  };

  var handleSubCategory = function handleSubCategory(item) {
    switch (selectedCategory) {
      case labels/* default.upgrade.planData.lbl_looking_for */.Z.upgrade.planData.lbl_looking_for:
        if (item === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only) {
          props.setSelectedModel();
          props.setSelectedBrand();
          setSelectedBrand();
          setSelectedModel();
        }

        props.setSelectedContractType(item);
        setDisplayCategory(true);
        setSelectedSubCategory("contractType");
        break;

      case "Brands":
        setSelectedSubCategory("brands");
        setSelectedBrand(item);
        break;

      case "Models":
        setSelectedSubCategory("models");
        setSelectedModel(item);
        break;

      default:
        break;
    }

    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({}, analyticsUtag/* getUtagData */.GS(["visitor_customer_id", "visitor_login_status", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "page_site_section_lvl_4", "visitor_msisdn_hash", "page_name", "page_channel", "page_master_tab", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"])), {}, {
      filter_query: item,
      page_tool_event: "use",
      page_tool_name: "".concat(analyticsUtag/* getPageName */.j0(), ": ").concat(selectedCategory, " filter")
    }));
  };

  var checkDisplay = function checkDisplay() {
    props.setShowModal(false);
    setDisplayCategory(true);
  };

  var handleFilters = function handleFilters() {
    if (displayCategory) {
      //apply filters
      props.applyFilters();
      props.setShowModal(false);
      props.setContractTypeFilterApplied(true);
      props.setBrandFilterApplied(true);
      props.setModelFilterApplied(true);
    } else {
      //save selections
      switch (selectedSubCategory) {
        case "brands":
          props.setSelectedBrand(selectedBrand);
          break;

        case "models":
          props.setSelectedModel(selectedModel);
          break;

        default:
          break;
      }

      setDisplayCategory(true);
    }
  };

  var handleReset = function handleReset() {
    switch (selectedSubCategory) {
      case "contractType":
        props.setSelectedContractType("");
        props.setSelectedBrand();
        props.setSelectedModel();
        break;

      case "brands":
        props.setSelectedBrand();
        setSelectedBrand();
        break;

      case "models":
        props.setSelectedModel();
        setSelectedModel();
        break;

      default:
        break;
    }

    setIsReset(true);
  };

  var isContractSelected = function isContractSelected() {
    return !!(props !== null && props !== void 0 && props.selectedContractType);
  };

  var handleDisableButton = function handleDisableButton() {
    if ((selectedBrand || selectedModel || props.selectedBrand || props.selectedModel || props.selectedContractType === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only) && isContractSelected()) {
      return false;
    } else {
      return true;
    }
  };

  var handleDisableItem = function handleDisableItem(item) {
    return props.selectedContractType === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only && item.name !== labels/* default.upgrade.planData.lbl_looking_for */.Z.upgrade.planData.lbl_looking_for || item.name == "Brands" && !isContractSelected() || item.name == "Models" && !props.selectedBrand;
  };

  var categoriesList = [{
    id: 1,
    name: labels/* default.upgrade.planData.lbl_looking_for */.Z.upgrade.planData.lbl_looking_for
  }, {
    id: 2,
    name: "Brands"
  }, {
    id: 3,
    name: "Models"
  }];

  var Categories = function Categories() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (UpgradeFiltersModal_module_default())["buttons-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "".concat((UpgradeFiltersModal_module_default()).button),
          onClick: checkDisplay,
          id: "backbtn-nav-bundlepage",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: "Arrow_icon-arrow__JlciI",
            src: "".concat(imagePrefix, "/assets/images/icon-arrow-left.svg")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (UpgradeFiltersModal_module_default())["category-title"],
          id: "filter-bundle-title",
          children: "Filters"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "".concat((UpgradeFiltersModal_module_default()).button, " ").concat((UpgradeFiltersModal_module_default()).reset),
          onClick: handleResetAll,
          id: "reset-nav-bundlepage",
          children: "Reset All"
        })]
      }), categoriesList && categoriesList.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "".concat((UpgradeFiltersModal_module_default())["category-container"], " ").concat(handleSelections(item, "category") ? "py-m" : "py-l"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((UpgradeFiltersModal_module_default()).category, " ").concat(handleDisableItem(item) ? (UpgradeFiltersModal_module_default()).disabled : ""),
            onClick: function onClick() {
              return handleCategory(item);
            },
            children: [item.name, /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
              className: "v-icon-chevron-right ".concat((UpgradeFiltersModal_module_default()).arrow, " ").concat(handleSelections(item, "category") ? (UpgradeFiltersModal_module_default()).selection_for : "", " ").concat(item.id == 1 ? (UpgradeFiltersModal_module_default()).looking_for : "")
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((UpgradeFiltersModal_module_default())["selected-values"]),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sub-item ".concat(handleSelections(item, "category") && (UpgradeFiltersModal_module_default())["selected-values__label"]),
              children: handleSelections(item, "category")
            })
          })]
        });
      })]
    });
  };

  var SubCategories = function SubCategories() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (UpgradeFiltersModal_module_default())["buttons-section"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "".concat((UpgradeFiltersModal_module_default()).button),
          onClick: handleBackbtn,
          id: "backbtn-nav-bundlepage",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: "Arrow_icon-arrow__JlciI",
            src: "".concat(imagePrefix, "/assets/images/icon-arrow-left.svg")
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (UpgradeFiltersModal_module_default())["category-title"],
          id: "filter-bundle-title",
          children: "Filters"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "".concat((UpgradeFiltersModal_module_default()).button, " ").concat((UpgradeFiltersModal_module_default()).reset),
          onClick: handleReset,
          id: "reset-nav-bundlepage",
          children: "Reset"
        })]
      }), subCatgeory && subCatgeory.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((UpgradeFiltersModal_module_default())["sub-category"], " ").concat(handleSelections(selectedCategory, "subcategory") == item && (UpgradeFiltersModal_module_default())["active-option"]),
          onClick: function onClick() {
            return handleSubCategory(item);
          },
          children: item
        });
      })]
    });
  };

  var FilterFooter = function FilterFooter() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: (displayCategory || selectedCategory != labels/* default.upgrade.planData.lbl_looking_for */.Z.upgrade.planData.lbl_looking_for) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((UpgradeFiltersModal_module_default())["show-results"], " ").concat(handleDisableButton() ? (UpgradeFiltersModal_module_default()).disabled : ""),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: displayCategory ? (UpgradeFiltersModal_module_default())["show-results__button"] : (UpgradeFiltersModal_module_default())["show-results__save-selection"],
          onClick: handleFilters,
          children: displayCategory ? "Apply filters" : labels/* default.lbl_save_selection */.Z.lbl_save_selection
        })
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal, {
      show: props.showModal,
      onHide: checkDisplay,
      dialogClassName: "select-modal",
      children: [displayCategory ? /*#__PURE__*/(0,jsx_runtime.jsx)(Categories, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SubCategories, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterFooter, {})]
    })
  });
};

/* harmony default export */ var UpgradeFiltersModal_UpgradeFiltersModal = (UpgradeFiltersModal);
// EXTERNAL MODULE: ./components/molecules/upgradeTopContainer/UpgradeTopContainer.module.scss
var UpgradeTopContainer_module = __webpack_require__(1234);
var UpgradeTopContainer_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeTopContainer_module);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./components/atoms/buttons/buttonWithIcon/ButtonWithIcon.jsx
var ButtonWithIcon = __webpack_require__(30390);
// EXTERNAL MODULE: ./Redux/actions/upgradeAction.js
var upgradeAction = __webpack_require__(58486);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
;// CONCATENATED MODULE: ./components/molecules/upgradeTopContainer/UpgradeTopContainer.jsx


function UpgradeTopContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UpgradeTopContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UpgradeTopContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UpgradeTopContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var UpgradeTopContainer = function UpgradeTopContainer(props) {
  var _props$staticText;

  var env = (config_default()).env;
  var numRegEx = RegExp(/^[0-9]*$/);
  var cellPhoneRegEx = RegExp(/^0[0-9]*$/);
  var msisdnRegEx = RegExp(/^27[0-9]*$/);
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < 577;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() < 992;
  var isDesktop = (0,helperServices/* componentCheckSize */.Qj)() > 992;

  var _useState = (0,react.useState)(false),
      showAccordion = _useState[0],
      setShowAccordion = _useState[1];

  var _useState2 = (0,react.useState)(),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var _useState3 = (0,react.useState)(true),
      isChecked = _useState3[0],
      setCheckedState = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isContinue = _useState4[0],
      setisContinue = _useState4[1];

  var _useState5 = (0,react.useState)(1),
      selectedRadio = _useState5[0],
      setSelectedRadio = _useState5[1];

  var _useState6 = (0,react.useState)(props.isPrevious),
      isPreviouslyChecked = _useState6[0],
      setIsPreviouslyChecked = _useState6[1];

  var _useState7 = (0,react.useState)(""),
      enteredCellNumber = _useState7[0],
      setEnteredCellNumber = _useState7[1];

  var _useState8 = (0,react.useState)(!props.isPrevious),
      isDefault = _useState8[0],
      setIsDefault = _useState8[1];

  var _useState9 = (0,react.useState)(props.linkedNumbers),
      linkedNum = _useState9[0],
      setLinkedNum = _useState9[1];

  var _useState10 = (0,react.useState)(),
      selectedAlternate = _useState10[0],
      setSelectedAlternate = _useState10[1];

  var handleContinue = function handleContinue() {
    var utagViewData = analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"]);
    utagViewData.page_name = getPageName();
    analyticsUtag/* link */.p4(UpgradeTopContainer_objectSpread({
      link_type: "o",
      link_name: "".concat(utagViewData.page_name, ": continue")
    }, utagViewData));

    if (props.selectedNumber) {
      props.updateUnmaskedMsisdn(props.selectedNumber);
    }

    if (!props.isAlternate) {
      if (!isChecked) {
        setLinkedNum([]);
        setIsDefault(false);
        props.fetchAlternateNumbers(props.selectedNumber);
        props.setIsPrevious(false);
      } else {
        props.updateMsisdnStatus((0,upgradeService/* maskMsisdn */.Ly)(props.selectedNumber), true);
        props.generateOneTimePin(props.selectedNumber).then(function () {
          props.displayHideUpgradeModal(!props.showUpgradeModal);
        });
      }
    } else {
      props.generateOTP(props.selectedNumber, selectedAlternate).then(function () {
        props.displayHideUpgradeModal(!props.showUpgradeModal);
      });
    }
  };

  var callbackRef = (0,react.useCallback)(function (inputFocus) {
    if (!props.isPrevious) {
      setTimeout(function () {
        if (inputFocus) {
          inputFocus.focus();
        }
      }, [300]);
    }
  }, []);

  var handleBackStep = function handleBackStep() {
    props.setisAlternate(false);

    if (props.upgradeCheckDone) {
      props.setIsPrevious(true);
    } else {
      setIsDefault(true);
    }

    var utagViewData = analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"]);
    utagViewData.page_name = getPageName();
    analyticsUtag/* link */.p4(UpgradeTopContainer_objectSpread({
      link_type: "o",
      link_name: "".concat(utagViewData.page_name, ": back")
    }, utagViewData));
  };

  var handleSelectedDropdownNum = function handleSelectedDropdownNum(item) {
    props.updateMsisdnStatus(item, true);
    setSelectedAlternate(item);
    setisContinue(true);
  };

  var handleSelected = function handleSelected(item) {
    setSelectedRadio(item.id);
    var utagViewData = analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
    utagViewData.page_name = props.isPrevious ? "shopping: upgrade: eligibility: another number" : "shopping: upgrade: eligibility";

    if (item.id == 1) {
      props.setSelectedNumber(props.unMaskedMsisdn);
      setEnteredCellNumber("");
      setErrorMessage("");
      utagViewData.page_tool_name = "".concat(utagViewData.page_name, ": previous number select");
    } else {
      props.setSelectedNumber();
      utagViewData.page_tool_name = "".concat(utagViewData.page_name, ": another number select");
    }

    analyticsUtag/* link */.p4(UpgradeTopContainer_objectSpread({
      page_channel: "shopping",
      page_master_tab: "personal",
      page_site_section_lvl_1: "upgrade",
      page_site_section_lvl_2: "home",
      page_tool_event: "use"
    }, utagViewData));
  };

  var handleCellNumber = function handleCellNumber(event) {
    //reset Invalid OTP Tries if the number is different
    if (props.selectedNumber !== event.target.value) {
      props.resetInvalidOtps();
    }

    getErrorMessage(event.target.value);
    setEnteredCellNumber(event.target.value);
    props.setSelectedNumber(event.target.value);
  };

  var toggleChange = function toggleChange(event) {
    setCheckedState(!isChecked);
    props.updateCanReciveOTP(!isChecked);
    var utagViewData = analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type", "upgrade_eligibility_status", "upgrade_ineligible_reason", "upgrade_eligible_date", "upgrade_customer_type"]);
    utagViewData.page_name = props.isPrevious ? "shopping: upgrade: eligibility: another number" : "shopping: upgrade: eligibility";
    analyticsUtag/* link */.p4(UpgradeTopContainer_objectSpread(UpgradeTopContainer_objectSpread({}, utagViewData), {}, {
      page_tool_event: "use",
      page_tool_name: "".concat(utagViewData.page_name, ": ").concat(isChecked ? "I can't use sms" : "I can use sms"),
      page_channel: "shopping",
      page_master_tab: "personal",
      page_site_section_lvl_1: "upgrade",
      page_site_section_lvl_2: "home"
    }));
  };

  var getErrorMessage = function getErrorMessage(value) {
    if (value && value.length > 0) {
      setErrorMessage("");

      if (numRegEx.test(value)) {
        if (!(cellPhoneRegEx.test(value) || msisdnRegEx.test(value))) {
          setErrorMessage("Number must start with 0 or 27 ");
        } else {
          setErrorMessage("");
        }
      } else {
        setErrorMessage("This field can only contain numbers");
      }
    } else {
      setErrorMessage("Please enter your cellphone number");
    }
  };

  var cellPhoneRadioOptions = [{
    id: 1,
    val: "The one I checked previously (".concat(props.msisdn, ")")
  }, {
    id: 2,
    val: "Another cellphone number"
  }];
  (0,react.useEffect)(function () {
    if (props.selectedNumber && props.selectedNumber.length == fetchMaxNumber() && !errorMessage || props.isPrevious && selectedRadio == 1) {
      setisContinue(true);
    } else {
      setisContinue(false);
    }
  }, [props.selectedNumber, isDefault]);

  var handleWonderClick = function handleWonderClick() {
    if (!showAccordion) {
      analyticsUtag/* link */.p4(UpgradeTopContainer_objectSpread({
        page_tool_event: "use",
        page_tool_name: "".concat(analyticsUtag/* getPageName */.j0(), ": what to expect")
      }, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
    }

    if (isTablet) {
      setShowAccordion(!showAccordion);
    } else {
      setShowAccordion(true);
    }
  };

  (0,react.useEffect)(function () {
    if (props.isAlternate) {
      setIsDefault(false);
      props.setIsPrevious(false);

      if (selectedAlternate) {
        setisContinue(true);
      } else {
        setisContinue(false);
      }
    }

    if (props.isPrevious) {
      setIsDefault(false);
    }
  }, [props.isAlternate, isDefault, props.isPrevious]);
  (0,react.useEffect)(function () {
    setLinkedNum(props.linkedNumbers);
  }, [props.linkedNumbers]);
  (0,react.useEffect)(function () {
    if (linkedNum.length > 0) {
      //props.displayHideUpgradeModal(false); //Need to comment this out since this causes modal popup not to appear in alternative numbers
      setIsDefault(false);
      props.setisAlternate(true);
    } else {
      if ((props.isAlternate || !isChecked) && props.upgradeStatus === upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR) {
        props.setisAlternate(false);
        props.displayHideUpgradeModal(true);
      }

      setIsDefault(!props.isPrevious);
    }
  }, [linkedNum, props.upgradeStatus]);

  var fetchMaxNumber = function fetchMaxNumber() {
    var maxNumber = 11;

    if (cellPhoneRegEx.test(props.selectedNumber)) {
      maxNumber = 10;
    }

    return maxNumber;
  };

  var getPageName = function getPageName() {
    if (props.isAlternate) {
      return "shopping: upgrade: eligibility: send otp";
    } else {
      return props.isPrevious ? "shopping: upgrade: eligibility: another number" : "shopping: upgrade: eligibility";
    }
  };

  (0,react.useEffect)(function () {
    if (errorMessage) {
      analyticsUtag/* link */.p4({
        page_name: props.isPrevious ? "shopping: upgrade: eligibility: another number" : "shopping: upgrade: eligibility",
        page_form_name: "shopping: upgrade: forms: ".concat(isMobile ? labels/* default.lbl_upgrade_page_heading_mobile */.Z.lbl_upgrade_page_heading_mobile : labels/* default.lbl_upgrade_page_heading */.Z.lbl_upgrade_page_heading),
        page_form_event: "error",
        page_errors: errorMessage,
        page_error_type: "form"
      });
    }
  }, [errorMessage]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (UpgradeTopContainer_module_default())["upgrade-top-container"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (UpgradeTopContainer_module_default())["upgrade-top-container__paragraph"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeTopContainer_module_default())["upgrade-top-container__paragraph__heading"],
        children: isMobile ? labels/* default.lbl_upgrade_page_heading_mobile */.Z.lbl_upgrade_page_heading_mobile : labels/* default.lbl_upgrade_page_heading */.Z.lbl_upgrade_page_heading
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeTopContainer_module_default())["upgrade-top-container__paragraph__description"],
        children: labels/* default.lbl_upgrade_page_description */.Z.lbl_upgrade_page_description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: (UpgradeTopContainer_module_default())["upgrade-top-container__otp"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        lg: 7,
        md: 12,
        xs: 12,
        className: "".concat((UpgradeTopContainer_module_default())["upgrade-top-container__otp__number-input"], " ").concat((UpgradeTopContainer_module_default())["otp-section"]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (UpgradeTopContainer_module_default())["upgrade-top-container__otp__number-input__heading"],
          children: [!props.isAlternate && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default())["upgrade-top-container__otp__number-input__heading__image"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/signed-profile.svg"),
              width: 24,
              height: 24
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: props.isAlternate && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
                className: (UpgradeTopContainer_module_default())["back-btn"],
                labelText: "Back",
                img_url_inactive: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
                img_url_active: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
                img_width: 12,
                img_height: 12,
                clickHandler: handleBackStep
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (UpgradeTopContainer_module_default())["upgrade-top-container__otp__number-input__heading__image"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "".concat(imagePrefix, "/assets/images/alternate-msg.svg"),
                  width: 24,
                  height: 24
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (UpgradeTopContainer_module_default())["where-can-heading"],
                children: "Where can we send your OTP ?"
              })]
            })
          }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default())["default-heading"],
            children: [" ", !props.isAlternate && labels/* default.lbl_which_number_mobile */.Z.lbl_which_number_mobile]
          }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default())["default-heading"],
            children: [" ", !props.isAlternate && labels/* default.lbl_which_number */.Z.lbl_which_number]
          })]
        }), props.isPrevious && !props.isAlternate && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [(cellPhoneRadioOptions === null || cellPhoneRadioOptions === void 0 ? void 0 : cellPhoneRadioOptions.length) > 0 && cellPhoneRadioOptions.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "mb-l",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                htmlFor: "radio-btn-".concat(item.id),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "radio",
                  name: "cellPhone",
                  checked: item.id == selectedRadio,
                  id: "radio-btn-".concat(item.id),
                  onClick: function onClick() {
                    return handleSelected(item);
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "".concat((UpgradeTopContainer_module_default())["previous-radio-label"], " ").concat(item.id == selectedRadio ? (UpgradeTopContainer_module_default())["selected-num"] : ""),
                  children: item.val
                })]
              })
            }, "phone-".concat(item.id, "-").concat(index));
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: props.isPrevious && selectedRadio == 1 && (UpgradeTopContainer_module_default()).disabled,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: (UpgradeTopContainer_module_default())["cell-phone"],
              children: [" ", "Cellphone number"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              className: (UpgradeTopContainer_module_default())["cell-label"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                type: "text",
                onChange: function onChange(event) {
                  return handleCellNumber(event);
                },
                name: "cellNumber",
                value: enteredCellNumber,
                maxLength: fetchMaxNumber(),
                placeholder: "Enter your cellphone number",
                ref: callbackRef,
                className: "".concat((UpgradeTopContainer_module_default())["cell-number"], " ").concat(errorMessage && (UpgradeTopContainer_module_default())["error-input"]),
                autofocus: true
              })
            }), errorMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (UpgradeTopContainer_module_default()).error,
              children: errorMessage
            })]
          })]
        }), props.isAlternate && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default())["cell-phone"],
            children: "Alternative cellphone number"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.DropdownButton, {
            id: "dropdown-basic-button",
            bsPrefix: (UpgradeTopContainer_module_default())["drop-down"],
            title: selectedAlternate ? selectedAlternate : "-Select-",
            children: linkedNum && linkedNum.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: (UpgradeTopContainer_module_default())["drop-down-item"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Dropdown.Item, {
                  onClick: function onClick() {
                    return handleSelectedDropdownNum(item);
                  },
                  children: item
                })
              }, "linked-".concat(index));
            })
          })]
        }), isDefault && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default())["cell-phone"],
            children: [" ", "Cellphone number"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (UpgradeTopContainer_module_default())["input-label-container"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", (0,defineProperty/* default */.Z)({
              type: "text",
              onChange: function onChange(event) {
                return handleCellNumber(event);
              },
              value: props.selectedNumber,
              placeholder: "Enter your cellphone number",
              name: "cellNumber",
              maxLength: fetchMaxNumber(),
              ref: callbackRef,
              className: "".concat((UpgradeTopContainer_module_default())["cell-number"], " ").concat(errorMessage && (UpgradeTopContainer_module_default())["error-input"])
            }, "placeholder", "Enter your cellphone number"))
          }), errorMessage && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default()).error,
            children: errorMessage
          })]
        }), !props.isAlternate && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((UpgradeTopContainer_module_default())["checkbox-container"], " ").concat(props.isPrevious && selectedRadio == 1 && (UpgradeTopContainer_module_default()).disabled),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: (UpgradeTopContainer_module_default())["checkbox-label"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "checkbox",
              id: props.id,
              value: "check-one",
              checked: isChecked,
              onChange: function onChange(event) {
                return toggleChange(event);
              },
              className: (UpgradeTopContainer_module_default())["checkbox-input"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (UpgradeTopContainer_module_default())["checkbox-span"],
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)("I can receive an SMS on this number")
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat(!isContinue && (UpgradeTopContainer_module_default()).disabled, " static-button-wrapper"),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
            type: "submit",
            className: "static-button ".concat((UpgradeTopContainer_module_default())["main-cta"]),
            variant: "solid red",
            id: "static-special-needs-form-submit",
            disabled: !isContinue,
            handleClick: handleContinue,
            children: "Continue"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        className: "".concat((UpgradeTopContainer_module_default())["upgrade-top-container__otp__what-to-expect"], " ").concat((UpgradeTopContainer_module_default())["otp-section"]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (UpgradeTopContainer_module_default())["upgrade-top-container__accordion__heading"],
          onClick: handleWonderClick,
          children: [props.staticText.title, /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            children: [(isTablet || isMobile) && !showAccordion && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/chevron-down-black.svg"),
              width: 18,
              height: 9
            }), (isTablet || isMobile) && showAccordion && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/chevron-up-black.svg"),
              width: 18,
              height: 9
            })]
          })]
        }), (isDesktop ? isDesktop : showAccordion) && (props === null || props === void 0 ? void 0 : props.staticText) && (props === null || props === void 0 ? void 0 : (_props$staticText = props.staticText) === null || _props$staticText === void 0 ? void 0 : _props$staticText.items.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (UpgradeTopContainer_module_default())["offers-text"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (UpgradeTopContainer_module_default())["offers-text__icon"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item.icon,
                height: 24
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (UpgradeTopContainer_module_default())["offers-text__description"],
              dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description)
            })]
          }, "static-".concat(index));
        }))]
      })]
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    showUpgradeModal: state.upgrade.showModal,
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    upgradeResponse: state.upgrade.upgradeResponse,
    displayData: state.upgrade.displayData,
    linkedNumbers: state.upgrade.linkedNumbers,
    msisdn: state.upgrade.msisdn,
    upgradeStatus: state.upgrade.upgradeStatus,
    unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
    allUpgradesData: state.upgrade.allUpgradesData
  };
};

/* harmony default export */ var upgradeTopContainer_UpgradeTopContainer = ((0,DependencyHelper.connect)(mapStateToProps, {
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  generateOneTimePin: upgradeAction/* generateOneTimePin */.ow,
  updateMsisdnStatus: upgradeAction/* updateMsisdnStatus */.Pl,
  generateOTP: upgradeAction/* generateOTP */.P,
  fetchAlternateNumbers: upgradeAction/* fetchAlternateNumbers */.CC,
  updateUpgradeRedirect: upgradeAction/* updateUpgradeRedirect */.z9,
  updateUnmaskedMsisdn: upgradeAction/* updateUnmaskedMsisdn */.c7,
  updateCanReciveOTP: upgradeAction/* updateCanReciveOTP */.rn,
  updateJourneyStatus: upgradeAction/* updateJourneyStatus */.aI,
  resetInvalidOtps: upgradeAction/* resetInvalidOtps */.$G
})(UpgradeTopContainer));
// EXTERNAL MODULE: ./components/atoms/buttons/carouselButton/CarouselButton.jsx
var CarouselButton = __webpack_require__(30698);
;// CONCATENATED MODULE: ./components/organisms/upgradeCard/UpgradeCard.jsx






var UpgradeCard = function UpgradeCard(props) {
  var isTablet = componentCheckSize() < 992;
  var cardData = props.cardData;
  return /*#__PURE__*/_jsxs(Row, {
    className: styles["upgrade-card"],
    children: [/*#__PURE__*/_jsxs(Col, {
      md: 7,
      className: styles["upgrade-card__text-container"],
      children: [!isTablet && /*#__PURE__*/_jsx(CustomContainer, {
        className: styles["card-title"],
        children: cardData.title
      }), /*#__PURE__*/_jsx(CustomContainer, {
        className: styles["card-sub_title"],
        children: cardData.subTitle
      }), /*#__PURE__*/_jsx(CustomContainer, {
        className: styles["card-description"],
        dangerouslySetInnerHTML: createMarkup(cardData.description)
      })]
    }), /*#__PURE__*/_jsx(Col, {
      md: 5,
      className: styles["upgrade-card__image-container"],
      children: /*#__PURE__*/_jsx("img", {
        src: cardData.image
      })
    })]
  });
};

/* harmony default export */ var upgradeCard_UpgradeCard = ((/* unused pure expression or super */ null && (UpgradeCard)));
// EXTERNAL MODULE: ./components/organisms/UpgradeCarousel/UpgradeCarousel.module.scss
var UpgradeCarousel_module = __webpack_require__(38842);
var UpgradeCarousel_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeCarousel_module);
;// CONCATENATED MODULE: ./components/organisms/UpgradeCarousel/UpgradeCarousel.jsx


function UpgradeCarousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UpgradeCarousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UpgradeCarousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UpgradeCarousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var UpgradeCarousel = function UpgradeCarousel(props) {
  var _useState = (0,react.useState)(""),
      previousNavClass = _useState[0],
      setPreviousNavClass = _useState[1];

  var _useState2 = (0,react.useState)(""),
      nextNavClass = _useState2[0],
      setNextNavClass = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      customCSS = _useState3[0],
      setCustomCSS = _useState3[1];

  var isDesktop = (0,helperServices/* componentCheckSize */.Qj)() > 992;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < 576;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;

  var _useState4 = (0,react.useState)(false),
      showAccordion = _useState4[0],
      setShowAccordion = _useState4[1];

  var upgradeCarousel;
  (0,react.useEffect)(function () {
    setShowAccordion(true);
  }, []);
  (0,react.useEffect)(function () {
    if (isDesktop && (props === null || props === void 0 ? void 0 : props.positionX) >= 0) {
      setCustomCSS({
        marginLeft: "".concat(props.positionX + 15, "px!important"),
        paddingLeft: "0!important"
      });
    }
  }, [isDesktop, props === null || props === void 0 ? void 0 : props.positionX]);

  var next = function next() {
    if (upgradeCarousel) {
      upgradeCarousel.next(600);
    }
  };

  var prev = function prev() {
    if (upgradeCarousel) {
      upgradeCarousel.prev(600);
    }
  };

  var carouselOptions = {
    nav: false,
    autoplay: false,
    animateIn: "animate__fadeIn",
    margin: isDesktop ? 32 : 16,
    autoWidth: true,
    lazyLoad: true,
    dotsClass: false,
    dotClass: false,
    slideBy: 1,
    dots: false,
    loop: false,
    center: false,
    responsive: {
      0: {
        slideBy: 1
      }
    }
  };
  var events = {
    onInitialized: function onInitialized(event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function onTranslated(event) {
      toggleCarouselNavDisabled(event);
    }
  };

  function toggleCarouselNavDisabled(event) {
    var index = event.item.index;
    var minimum = 0;
    var maximum = event.item.count;
    var previousNav = index <= minimum ? "disabled" : "";
    var nextNav = index + carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >= maximum ? "disabled" : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  var handleAccordion = function handleAccordion() {
    setShowAccordion(!showAccordion);

    if (!showAccordion) {
      analyticsUtag/* link */.p4(UpgradeCarousel_objectSpread({
        page_tool_event: "use",
        page_tool_name: "".concat(analyticsUtag/* getPageName */.j0(), ": why upgrade online")
      }, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: (UpgradeCarousel_module_default())["carousel-container"],
    children: !isDesktop && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
      className: (UpgradeCarousel_module_default())["mobile-accordion"],
      onClick: handleAccordion,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeCarousel_module_default())["upgrade-online-heading"],
        children: "Why upgrade online"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (UpgradeCarousel_module_default())["upgrade-accordion-symbol"],
        children: [!showAccordion && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          height: 9.5,
          width: 18,
          src: "".concat(imagePrefix, "/assets/images/chevron-down-black.svg")
        }), showAccordion && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          height: 9.5,
          width: 18,
          src: "".concat(imagePrefix, "/assets/images/chevron-up-black.svg")
        })]
      })]
    })
  });
};

/* harmony default export */ var UpgradeCarousel_UpgradeCarousel = (UpgradeCarousel);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./components/molecules/homeTabs/HomeTabs.jsx
var HomeTabs = __webpack_require__(2458);
;// CONCATENATED MODULE: ./components/molecules/MoreUpgradeDeals/MoreUpgradeDeals.jsx







var MoreUpgradeDeals = function MoreUpgradeDeals() {
  var handleQualifyDeals = function handleQualifyDeals() {
    Router.push("/shopping/deals");
    Analytics.link({
      link_type: "o",
      link_name: "shopping: upgrade: recommended deals: more:browse all deals"
    });
  };

  var handleProducts = function handleProducts() {
    Router.push('/shopping/products');
    Analytics.link({
      link_type: "o",
      link_name: "shopping: upgrade: recommended deals:  more:browse all products"
    });
  };

  return /*#__PURE__*/_jsxs(CustomContainer, {
    className: styles["more-upgrade"],
    children: [/*#__PURE__*/_jsx(CustomContainer, {
      className: styles["more-upgrade__heading"],
      children: "Can’t find a recommended deal you like?"
    }), /*#__PURE__*/_jsx(CustomContainer, {
      className: styles["more-upgrade__description"],
      children: "No problem! You can still find an upgrade deal by browsing the rest of our website."
    }), /*#__PURE__*/_jsx("span", {
      className: styles["more-upgrade__browse-btn"],
      children: /*#__PURE__*/_jsxs(CTAButton, {
        handleClick: handleQualifyDeals,
        variant: "primary",
        children: ["Browse all deals i qualify for ", " "]
      })
    }), /*#__PURE__*/_jsx(CTAButton, {
      handleClick: handleProducts,
      variant: "outline black",
      children: "Browse all products"
    })]
  });
};

/* harmony default export */ var MoreUpgradeDeals_MoreUpgradeDeals = ((/* unused pure expression or super */ null && (MoreUpgradeDeals)));
// EXTERNAL MODULE: ./components/organisms/dealListContainer/DealListContainer.jsx
var DealListContainer = __webpack_require__(70695);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./components/organisms/PastUsage/PastUsage.module.scss
var PastUsage_module = __webpack_require__(65280);
var PastUsage_module_default = /*#__PURE__*/__webpack_require__.n(PastUsage_module);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
;// CONCATENATED MODULE: ./components/organisms/PastUsage/PastUsage.jsx





















var PastUsage = function PastUsage(props) {
  var _convertToGB, _pastConsumption$cons2, _pastConsumption$cons3, _pastConsumption$cons4, _pastConsumption$cons5, _pastConsumption$curr, _pastConsumption$curr2, _pastConsumption$curr3, _pastConsumption$curr4, _convertToGB2, _pastConsumption$curr5, _pastConsumption$curr6, _convertToGB3, _pastConsumption$curr7, _pastConsumption$curr8, _pastConsumption$cons6, _pastConsumption$cons7, _pastConsumption$curr9, _pastConsumption$curr10, _pastConsumption$curr11, _pastConsumption$curr12, _pastConsumption$cons8, _pastConsumption$cons9, _pastConsumption$cons10, _pastConsumption$cons11, _pastConsumption$curr13, _pastConsumption$curr14, _pastConsumption$curr15, _pastConsumption$curr16, _pastConsumption$curr17, _pastConsumption$curr18, _pastConsumption$curr19, _pastConsumption$curr20, _pastConsumption$curr21, _pastConsumption$curr22, _pastConsumption$cons12, _pastConsumption$cons13, _pastConsumption$curr23, _pastConsumption$curr24, _pastConsumption$curr25, _pastConsumption$curr26, _pastConsumption$cons14, _pastConsumption$cons15, _pastConsumption$cons16, _pastConsumption$cons17, _pastConsumption$curr27, _pastConsumption$curr28, _pastConsumption$curr29, _pastConsumption$curr30, _pastConsumption$curr31, _pastConsumption$curr32, _pastConsumption$curr33, _pastConsumption$curr34, _pastConsumption$curr35, _pastConsumption$curr36, _pastConsumption$cons18, _pastConsumption$cons19, _pastConsumption$curr37, _pastConsumption$curr38, _pastConsumption$curr39, _pastConsumption$curr40, _pastConsumption$cons20, _pastConsumption$cons21, _pastConsumption$cons22, _pastConsumption$cons23, _pastConsumption$cons24, _pastConsumption$cons25, _pastConsumption$cons26, _pastConsumption$acco, _pastConsumption$acco2, _pastConsumption$curr41, _pastConsumption$curr42, _pastConsumption$cons27, _pastConsumption$curr43, _pastConsumption$cons28, _pastConsumption$Cust, _pastConsumption$curr44, _pastConsumption$curr45, _pastConsumption$cons29, _pastConsumption$curr46, _pastConsumption$curr47, _pastConsumption$curr48, _pastConsumption$curr49, _pastConsumption$curr50, _pastConsumption$curr51, _pastConsumption$curr52, _pastConsumption$curr53, _pastConsumption$curr54, _pastConsumption$curr55, _pastConsumption$curr56, _pastConsumption$curr57, _pastConsumption$curr58, _pastConsumption$curr59, _pastConsumption$curr60, _pastConsumption$curr61, _pastConsumption$curr62, _pastConsumption$curr63;

  var jwtToken = props.responseToken["x-auth-jwt"];
  /*
  useEffect(() => {
    props.getPastUsage(props.selectedNumber);
  }, [props.selectedNumber])
  */
  // const [pastUsage, setPastUsage] = useState(props.pastUsage);

  var _useState = (0,react.useState)(),
      pastConsumption = _useState[0],
      setPastConsumption = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isApiError = _useState2[0],
      setIsApiError = _useState2[1];

  var overSpendDescription = props.pastUsageParagraph.description;
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  (0,react.useEffect)(function () {
    var _pastConsumption$cons;

    // setPastUsage(props.pastUsageData);
    overSpendDescription = overSpendDescription.replace("[average_monthly_amount]&nbsp", "".concat(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons = pastConsumption.consumption) === null || _pastConsumption$cons === void 0 ? void 0 : _pastConsumption$cons.spendMinusSubsc));
  }, [pastConsumption]);

  var _useState3 = (0,react.useState)(""),
      activeAccordion = _useState3[0],
      setActiveAccordion = _useState3[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var imgUrl = "".concat(imagePrefix, "/assets/images/warning-black.svg");
  var errorImg = "".concat(imagePrefix, "/assets/images/error-circle-red.svg");
  var backImg = "".concat(imagePrefix, "/assets/images/triangle-arrow.svg");
  var btnConfig = {
    buttonStyle: "outline black",
    buttonLabel: "Back to top"
  };

  var goToTop = function goToTop() {
    analyticsUtag/* link */.p4({
      page_tool_event: "use",
      page_tool_name: "shopping: upgrade: recommended deals: back to top"
    });
    window.scrollTo(0, 0);
  };

  var convertToGB = function convertToGB(val) {
    if (val > 0) {
      return val / 1024;
    } else {
      return val;
    }
  };

  (0,react.useEffect)(function () {
    getConsumptionData();
  }, [props.selectedNumber]);

  var getConsumptionData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _responseData$respons, _responseData$respons2, _responseData$respons3, _responseData$respons4;

      var loginStatus, eligibilityToken, queryParams, responseData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              loginStatus = DependencyHelper.Cookie.get("vod-web-auth-token") ? true : false;
              eligibilityToken = DependencyHelper.Cookie.get("eligibility-token");
              queryParams = "?msisdn=".concat(props.selectedNumber);
              setPastConsumption();
              setIsApiError(false);
              _context.next = 8;
              return microServices/* default.get */.Z.get("api", "consumption", null, loginStatus, null, queryParams, false, loginStatus ? null : eligibilityToken);

            case 8:
              responseData = _context.sent;
              setPastConsumption(responseData === null || responseData === void 0 ? void 0 : (_responseData$respons = responseData.response) === null || _responseData$respons === void 0 ? void 0 : (_responseData$respons2 = _responseData$respons.data) === null || _responseData$respons2 === void 0 ? void 0 : _responseData$respons2.result);
              setIsApiError(!(responseData !== null && responseData !== void 0 && (_responseData$respons3 = responseData.response) !== null && _responseData$respons3 !== void 0 && (_responseData$respons4 = _responseData$respons3.data) !== null && _responseData$respons4 !== void 0 && _responseData$respons4.result));
              (0,helperServices/* hideSpinner */.v3)();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getConsumptionData() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (!pastConsumption) {
      analyticsUtag/* link */.p4({
        page_name: "shopping: upgrade: recommended deals",
        page_form_event: "error",
        page_errors: "We seem to be having some issues retrieving your past usage  data right now. Please try again later.",
        page_error_type: "page"
      });
    }
  }, [pastConsumption]);
  var tabNames = [{
    key: "MAU",
    title: "My average usage",
    description: "This is your average monthly data, voice and SMS usage over the past 6 months:",
    data: [{
      name: "Data",
      usage: "".concat((_convertToGB = convertToGB(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons2 = pastConsumption.consumption) === null || _pastConsumption$cons2 === void 0 ? void 0 : (_pastConsumption$cons3 = _pastConsumption$cons2.usage) === null || _pastConsumption$cons3 === void 0 ? void 0 : _pastConsumption$cons3.data)) === null || _convertToGB === void 0 ? void 0 : _convertToGB.toFixed(2), "GB"),
      des: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons4 = pastConsumption.consumption) === null || _pastConsumption$cons4 === void 0 ? void 0 : (_pastConsumption$cons5 = _pastConsumption$cons4.usage) === null || _pastConsumption$cons5 === void 0 ? void 0 : _pastConsumption$cons5.data) - (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr = pastConsumption.currentDeal) === null || _pastConsumption$curr === void 0 ? void 0 : (_pastConsumption$curr2 = _pastConsumption$curr.packages[0]) === null || _pastConsumption$curr2 === void 0 ? void 0 : _pastConsumption$curr2.includedData) < 0 ? "Your current plan  gives you <strong class =\"ml-xxs\"> ".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr3 = pastConsumption.currentDeal) === null || _pastConsumption$curr3 === void 0 ? void 0 : (_pastConsumption$curr4 = _pastConsumption$curr3.packages[0]) === null || _pastConsumption$curr4 === void 0 ? void 0 : _pastConsumption$curr4.includedData) == "-1" ? "Unlimited" : (_convertToGB2 = convertToGB(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr5 = pastConsumption.currentDeal) === null || _pastConsumption$curr5 === void 0 ? void 0 : (_pastConsumption$curr6 = _pastConsumption$curr5.packages[0]) === null || _pastConsumption$curr6 === void 0 ? void 0 : _pastConsumption$curr6.includedData)) === null || _convertToGB2 === void 0 ? void 0 : _convertToGB2.toFixed(1), " GB data</strong>") : "Your current plan only gives you <strong class =\"ml-xxs\">".concat((_convertToGB3 = convertToGB(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr7 = pastConsumption.currentDeal) === null || _pastConsumption$curr7 === void 0 ? void 0 : (_pastConsumption$curr8 = _pastConsumption$curr7.packages[0]) === null || _pastConsumption$curr8 === void 0 ? void 0 : _pastConsumption$curr8.includedData)) === null || _convertToGB3 === void 0 ? void 0 : _convertToGB3.toFixed(1), " GB data</strong> ")),
      error: Number(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons6 = pastConsumption.consumption) === null || _pastConsumption$cons6 === void 0 ? void 0 : (_pastConsumption$cons7 = _pastConsumption$cons6.usage) === null || _pastConsumption$cons7 === void 0 ? void 0 : _pastConsumption$cons7.data) - Number(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr9 = pastConsumption.currentDeal) === null || _pastConsumption$curr9 === void 0 ? void 0 : (_pastConsumption$curr10 = _pastConsumption$curr9.packages[0]) === null || _pastConsumption$curr10 === void 0 ? void 0 : _pastConsumption$curr10.includedData) > 0 && (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr11 = pastConsumption.currentDeal) === null || _pastConsumption$curr11 === void 0 ? void 0 : (_pastConsumption$curr12 = _pastConsumption$curr11.packages[0]) === null || _pastConsumption$curr12 === void 0 ? void 0 : _pastConsumption$curr12.includedData) != "-1" ? true : false
    }, {
      name: "Voice",
      usage: "".concat(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons8 = pastConsumption.consumption) === null || _pastConsumption$cons8 === void 0 ? void 0 : (_pastConsumption$cons9 = _pastConsumption$cons8.usage) === null || _pastConsumption$cons9 === void 0 ? void 0 : _pastConsumption$cons9.voice, " min"),
      des: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons10 = pastConsumption.consumption) === null || _pastConsumption$cons10 === void 0 ? void 0 : (_pastConsumption$cons11 = _pastConsumption$cons10.usage) === null || _pastConsumption$cons11 === void 0 ? void 0 : _pastConsumption$cons11.voice) - (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr13 = pastConsumption.currentDeal) === null || _pastConsumption$curr13 === void 0 ? void 0 : (_pastConsumption$curr14 = _pastConsumption$curr13.packages[0]) === null || _pastConsumption$curr14 === void 0 ? void 0 : _pastConsumption$curr14.includedMinutes) < 0 ? "Your current plan  gives you <strong class =\"ml-xxs\"> ".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr15 = pastConsumption.currentDeal) === null || _pastConsumption$curr15 === void 0 ? void 0 : (_pastConsumption$curr16 = _pastConsumption$curr15.packages[0]) === null || _pastConsumption$curr16 === void 0 ? void 0 : _pastConsumption$curr16.includedMinutes) == "-1" ? "Unlimited" : pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr17 = pastConsumption.currentDeal) === null || _pastConsumption$curr17 === void 0 ? void 0 : (_pastConsumption$curr18 = _pastConsumption$curr17.packages[0]) === null || _pastConsumption$curr18 === void 0 ? void 0 : _pastConsumption$curr18.includedMinutes, " minutes</strong>") : "Your current plan only gives you <strong class =\"ml-xxs\"> ".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr19 = pastConsumption.currentDeal) === null || _pastConsumption$curr19 === void 0 ? void 0 : (_pastConsumption$curr20 = _pastConsumption$curr19.packages[0]) === null || _pastConsumption$curr20 === void 0 ? void 0 : _pastConsumption$curr20.includedMinutes) == "-1" ? "Unlimited" : pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr21 = pastConsumption.currentDeal) === null || _pastConsumption$curr21 === void 0 ? void 0 : (_pastConsumption$curr22 = _pastConsumption$curr21.packages[0]) === null || _pastConsumption$curr22 === void 0 ? void 0 : _pastConsumption$curr22.includedMinutes, " minutes</strong>")),
      error: Number(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons12 = pastConsumption.consumption) === null || _pastConsumption$cons12 === void 0 ? void 0 : (_pastConsumption$cons13 = _pastConsumption$cons12.usage) === null || _pastConsumption$cons13 === void 0 ? void 0 : _pastConsumption$cons13.voice) - Number(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr23 = pastConsumption.currentDeal) === null || _pastConsumption$curr23 === void 0 ? void 0 : (_pastConsumption$curr24 = _pastConsumption$curr23.packages[0]) === null || _pastConsumption$curr24 === void 0 ? void 0 : _pastConsumption$curr24.includedMinutes) > 0 && (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr25 = pastConsumption.currentDeal) === null || _pastConsumption$curr25 === void 0 ? void 0 : (_pastConsumption$curr26 = _pastConsumption$curr25.packages[0]) === null || _pastConsumption$curr26 === void 0 ? void 0 : _pastConsumption$curr26.includedMinutes) != "-1" ? true : false
    }, {
      name: "SMS",
      usage: "".concat(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons14 = pastConsumption.consumption) === null || _pastConsumption$cons14 === void 0 ? void 0 : (_pastConsumption$cons15 = _pastConsumption$cons14.usage) === null || _pastConsumption$cons15 === void 0 ? void 0 : _pastConsumption$cons15.sms, " SMS"),
      des: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons16 = pastConsumption.consumption) === null || _pastConsumption$cons16 === void 0 ? void 0 : (_pastConsumption$cons17 = _pastConsumption$cons16.usage) === null || _pastConsumption$cons17 === void 0 ? void 0 : _pastConsumption$cons17.sms) - (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr27 = pastConsumption.currentDeal) === null || _pastConsumption$curr27 === void 0 ? void 0 : (_pastConsumption$curr28 = _pastConsumption$curr27.packages[0]) === null || _pastConsumption$curr28 === void 0 ? void 0 : _pastConsumption$curr28.includedSms) < 0 ? "Your current plan  gives you <strong class =\"ml-xxs\">".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr29 = pastConsumption.currentDeal) === null || _pastConsumption$curr29 === void 0 ? void 0 : (_pastConsumption$curr30 = _pastConsumption$curr29.packages[0]) === null || _pastConsumption$curr30 === void 0 ? void 0 : _pastConsumption$curr30.includedSms) == "-1" ? "Unlimited" : pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr31 = pastConsumption.currentDeal) === null || _pastConsumption$curr31 === void 0 ? void 0 : (_pastConsumption$curr32 = _pastConsumption$curr31.packages[0]) === null || _pastConsumption$curr32 === void 0 ? void 0 : _pastConsumption$curr32.includedSms, " SMSs</strong>") : "Your current plan only gives you <strong class =\"ml-xxs\">".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr33 = pastConsumption.currentDeal) === null || _pastConsumption$curr33 === void 0 ? void 0 : (_pastConsumption$curr34 = _pastConsumption$curr33.packages[0]) === null || _pastConsumption$curr34 === void 0 ? void 0 : _pastConsumption$curr34.includedSms) == "-1" ? "Unlimited" : pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr35 = pastConsumption.currentDeal) === null || _pastConsumption$curr35 === void 0 ? void 0 : (_pastConsumption$curr36 = _pastConsumption$curr35.packages[0]) === null || _pastConsumption$curr36 === void 0 ? void 0 : _pastConsumption$curr36.includedSms, " SMSs</strong>")),
      error: Number(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons18 = pastConsumption.consumption) === null || _pastConsumption$cons18 === void 0 ? void 0 : (_pastConsumption$cons19 = _pastConsumption$cons18.usage) === null || _pastConsumption$cons19 === void 0 ? void 0 : _pastConsumption$cons19.sms) - Number(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr37 = pastConsumption.currentDeal) === null || _pastConsumption$curr37 === void 0 ? void 0 : (_pastConsumption$curr38 = _pastConsumption$curr37.packages[0]) === null || _pastConsumption$curr38 === void 0 ? void 0 : _pastConsumption$curr38.includedSms) > 0 && (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr39 = pastConsumption.currentDeal) === null || _pastConsumption$curr39 === void 0 ? void 0 : (_pastConsumption$curr40 = _pastConsumption$curr39.packages[0]) === null || _pastConsumption$curr40 === void 0 ? void 0 : _pastConsumption$curr40.includedSms) != "-1" ? true : false
    }]
  }, {
    key: "MAS",
    title: "My average spend",
    description: "This is your average monthly spend over the past 6 months:",
    data: [{
      name: "Average monthly spend",
      usage: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons20 = pastConsumption.consumption) === null || _pastConsumption$cons20 === void 0 ? void 0 : (_pastConsumption$cons21 = _pastConsumption$cons20.averageSpend) === null || _pastConsumption$cons21 === void 0 ? void 0 : _pastConsumption$cons21.toFixed(2)) || "-", "PM"),
      des: "Your monthly contract cost is <strong class=\"ml-xxs\">R ".concat(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons22 = pastConsumption.consumption) === null || _pastConsumption$cons22 === void 0 ? void 0 : _pastConsumption$cons22.bill, " PM</strong>"),
      error: (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons23 = pastConsumption.consumption) === null || _pastConsumption$cons23 === void 0 ? void 0 : _pastConsumption$cons23.spendMinusSubsc) > 0
    }, {
      name: "Average overspend per month",
      usage: "R".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons24 = pastConsumption.consumption) === null || _pastConsumption$cons24 === void 0 ? void 0 : (_pastConsumption$cons25 = _pastConsumption$cons24.spendMinusSubsc) === null || _pastConsumption$cons25 === void 0 ? void 0 : _pastConsumption$cons25.toFixed(2)) || "-"),
      hidden: (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons26 = pastConsumption.consumption) === null || _pastConsumption$cons26 === void 0 ? void 0 : _pastConsumption$cons26.spendMinusSubsc) < 0
    }],
    overSpend: {
      title: "Why did I overspend?",
      overDesCription: "On average, your total bill amount was R60.99 more than your monthly contract cost. This is most likely due to going out-of-bundle on your data, voice and/or SMS allocations, or activating other services on your account. For more information, view your statement or contact Customer Care at 082 135.",
      overDesCription1: "To avoid overspending, you can select a deal with a Top Up plan, which won’t let you use more data or minutes unless you top up."
    }
  }, {
    key: "MCC",
    title: "My current contract",
    description: "",
    contract_data: [{
      type: "Contract details",
      data: [{
        label: "Contract duration",
        value: "-"
      }, {
        label: "Contract start date",
        value: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$acco = pastConsumption.accountSummary) === null || _pastConsumption$acco === void 0 ? void 0 : _pastConsumption$acco.startDate) || "-")
      }, {
        label: "Contract end date",
        value: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$acco2 = pastConsumption.accountSummary) === null || _pastConsumption$acco2 === void 0 ? void 0 : _pastConsumption$acco2.endDate) || "-")
      }, {
        label: "Contract type",
        value: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr41 = pastConsumption.currentDeal) === null || _pastConsumption$curr41 === void 0 ? void 0 : (_pastConsumption$curr42 = _pastConsumption$curr41.packages[0]) === null || _pastConsumption$curr42 === void 0 ? void 0 : _pastConsumption$curr42.packageTypeName) || "-")
      }, {
        label: "Total monthly contract cost:",
        value: "R ".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons27 = pastConsumption.consumption) === null || _pastConsumption$cons27 === void 0 ? void 0 : _pastConsumption$cons27.bill) || "-")
      }]
    }, {
      type: "Device details",
      data: [{
        label: "Device name",
        value: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr43 = pastConsumption.currentDevice) === null || _pastConsumption$curr43 === void 0 ? void 0 : _pastConsumption$curr43.deviceModel) || "-")
      }, {
        label: "Monthly device cost",
        value: "R ".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons28 = pastConsumption.consumption) === null || _pastConsumption$cons28 === void 0 ? void 0 : _pastConsumption$cons28.handsetFinance) || "-")
      }]
    }, {
      type: "Plan details",
      data: [{
        label: "Plan name",
        value: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$Cust = pastConsumption.Customer) === null || _pastConsumption$Cust === void 0 ? void 0 : _pastConsumption$Cust.currentTariff) || "-")
      }, {
        label: "Plan type",
        value: "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr44 = pastConsumption.currentDeal) === null || _pastConsumption$curr44 === void 0 ? void 0 : (_pastConsumption$curr45 = _pastConsumption$curr44.packages[0]) === null || _pastConsumption$curr45 === void 0 ? void 0 : _pastConsumption$curr45.planType) || "-")
      }, {
        label: "Monthly plan cost",
        value: "R ".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons29 = pastConsumption.consumption) === null || _pastConsumption$cons29 === void 0 ? void 0 : _pastConsumption$cons29.subscription) || "-")
      }, {
        label: "Any time data",
        value: pastConsumption !== null && pastConsumption !== void 0 && (_pastConsumption$curr46 = pastConsumption.currentDeal) !== null && _pastConsumption$curr46 !== void 0 && (_pastConsumption$curr47 = _pastConsumption$curr46.packages[0]) !== null && _pastConsumption$curr47 !== void 0 && _pastConsumption$curr47.includedData ? "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr48 = pastConsumption.currentDeal) === null || _pastConsumption$curr48 === void 0 ? void 0 : (_pastConsumption$curr49 = _pastConsumption$curr48.packages[0]) === null || _pastConsumption$curr49 === void 0 ? void 0 : _pastConsumption$curr49.includedData) == "-1" ? "Unlimited" : convertToGB(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr50 = pastConsumption.currentDeal) === null || _pastConsumption$curr50 === void 0 ? void 0 : (_pastConsumption$curr51 = _pastConsumption$curr50.packages[0]) === null || _pastConsumption$curr51 === void 0 ? void 0 : _pastConsumption$curr51.includedData), " GB") : "-"
      }, {
        label: "Voice",
        value: pastConsumption !== null && pastConsumption !== void 0 && (_pastConsumption$curr52 = pastConsumption.currentDeal) !== null && _pastConsumption$curr52 !== void 0 && (_pastConsumption$curr53 = _pastConsumption$curr52.packages[0]) !== null && _pastConsumption$curr53 !== void 0 && _pastConsumption$curr53.includedMinutes ? "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr54 = pastConsumption.currentDeal) === null || _pastConsumption$curr54 === void 0 ? void 0 : (_pastConsumption$curr55 = _pastConsumption$curr54.packages[0]) === null || _pastConsumption$curr55 === void 0 ? void 0 : _pastConsumption$curr55.includedMinutes) == "-1" ? "Unlimited" : pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr56 = pastConsumption.currentDeal) === null || _pastConsumption$curr56 === void 0 ? void 0 : (_pastConsumption$curr57 = _pastConsumption$curr56.packages[0]) === null || _pastConsumption$curr57 === void 0 ? void 0 : _pastConsumption$curr57.includedMinutes, " minutes") : "-"
      }, {
        label: "SMS",
        value: pastConsumption !== null && pastConsumption !== void 0 && (_pastConsumption$curr58 = pastConsumption.currentDeal) !== null && _pastConsumption$curr58 !== void 0 && (_pastConsumption$curr59 = _pastConsumption$curr58.packages[0]) !== null && _pastConsumption$curr59 !== void 0 && _pastConsumption$curr59.includedSms ? "".concat((pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr60 = pastConsumption.currentDeal) === null || _pastConsumption$curr60 === void 0 ? void 0 : (_pastConsumption$curr61 = _pastConsumption$curr60.packages[0]) === null || _pastConsumption$curr61 === void 0 ? void 0 : _pastConsumption$curr61.includedSms) == "-1" ? "Unlimited" : pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$curr62 = pastConsumption.currentDeal) === null || _pastConsumption$curr62 === void 0 ? void 0 : (_pastConsumption$curr63 = _pastConsumption$curr62.packages[0]) === null || _pastConsumption$curr63 === void 0 ? void 0 : _pastConsumption$curr63.includedSms, " Sms") : "-"
      }, {
        label: "Airtime",
        value: "-"
      }]
    }]
  }];

  var generateClass = function generateClass(eventKey) {
    return eventKey === activeAccordion ? "".concat((PastUsage_module_default()).accordion__toggle, " ").concat((PastUsage_module_default())["accordion__toggle--active"]) : (PastUsage_module_default()).accordion__toggle;
  };

  var accordElem = (0,react.useRef)(null);

  var CustomToggle = function CustomToggle(_ref2) {
    var children = _ref2.children,
        eventKey = _ref2.eventKey;
    var decoratedOnClick = (0,DependencyHelper.useAccordionToggle)(eventKey, function () {
      if (eventKey === activeAccordion) {
        setActiveAccordion("");
      } else {
        var _accordElem$current;

        setActiveAccordion(eventKey);
        accordElem === null || accordElem === void 0 ? void 0 : (_accordElem$current = accordElem.current) === null || _accordElem$current === void 0 ? void 0 : _accordElem$current.scrollIntoView();
      }
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: generateClass(eventKey),
      onClick: decoratedOnClick,
      children: children
    });
  }; //  && pastUsage?.usage


  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      className: (PastUsage_module_default())["go-back-btn"],
      onClick: function onClick() {
        return props.setActiveTab("Recommended deals");
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (PastUsage_module_default())["back-img"],
          src: backImg,
          height: 12
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Go back to deals"
      })]
    }), pastConsumption ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
        className: "d-none d-md-block d-lg-block",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Tab.Content, {
            className: "".concat((PastUsage_module_default())["tab-content"]),
            children: tabNames.map(function (tab, index) {
              var _pastConsumption$cons30, _props$pastUsageParag, _pastConsumption$cons31, _pastConsumption$cons32;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                  className: (PastUsage_module_default())["accordion-title"],
                  children: tab.title
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: tab.description
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
                    className: (PastUsage_module_default())["pastusage-content-boxes"],
                    children: tab.data && tab.data.length > 0 && (tab === null || tab === void 0 ? void 0 : tab.data.map(function (d) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                        md: 6,
                        lg: 4,
                        className: "".concat((PastUsage_module_default())["box-container"], " pr-0  ").concat(d.hidden && (PastUsage_module_default())["hide-block"]),
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
                          className: (PastUsage_module_default()).boxes,
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                            children: d.name
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                            className: "".concat((PastUsage_module_default())["data-usage"], " ").concat(d.error && (PastUsage_module_default())["error-warning"]),
                            children: [d.error && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                              className: (PastUsage_module_default())["error-icon"],
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                                src: errorImg,
                                width: 30
                              })
                            }), d.usage]
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                            className: "".concat((PastUsage_module_default())["data-des"], " ").concat(d.error && (PastUsage_module_default())["error-warning--des"]),
                            dangerouslySetInnerHTML: {
                              __html: d.des
                            }
                          })]
                        }, d.name)
                      });
                    }))
                  }), tab.overSpend && (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons30 = pastConsumption.consumption) === null || _pastConsumption$cons30 === void 0 ? void 0 : _pastConsumption$cons30.spendMinusSubsc) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                    className: (PastUsage_module_default())["OverSpend-div"],
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                      className: (PastUsage_module_default())["OverSpend-div__title"],
                      dangerouslySetInnerHTML: {
                        __html: (_props$pastUsageParag = props.pastUsageParagraph) === null || _props$pastUsageParag === void 0 ? void 0 : _props$pastUsageParag.heading
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                      className: (PastUsage_module_default())["OverSpend-div__description"],
                      dangerouslySetInnerHTML: {
                        __html: overSpendDescription.replace("[average_monthly_amount]&nbsp;", "<strong>".concat(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons31 = pastConsumption.consumption) === null || _pastConsumption$cons31 === void 0 ? void 0 : (_pastConsumption$cons32 = _pastConsumption$cons31.spendMinusSubsc) === null || _pastConsumption$cons32 === void 0 ? void 0 : _pastConsumption$cons32.toFixed(2), " </strong>"))
                      }
                    })]
                  }) : "", tab.contract_data && tab.contract_data.length > 0 && tab.contract_data.map(function (contract) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                        className: (PastUsage_module_default())["contract-type"],
                        children: contract.type
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                        className: (PastUsage_module_default())["details-deal-sub-section"],
                        children: contract.data.map(function (tbl_dt) {
                          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
                            className: "mx-0 ".concat((PastUsage_module_default())["details-section-row"]),
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                              md: 6 // xs={activeTab == "DESC" ? 6 : 12}
                              ,
                              xs: 12,
                              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                                className: "".concat((PastUsage_module_default())["details-label"]),
                                children: [tbl_dt.label, ":"]
                              })
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                              md: 6 // xs={activeTab == "DESC" ? 6 : 12}
                              ,
                              xs: 12,
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                                className: (PastUsage_module_default())["details-value"],
                                children: tbl_dt.value
                              })
                            })]
                          });
                        })
                      })]
                    });
                  })]
                })]
              });
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          xs: 12,
          className: "d-block d-md-none d-lg-none",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Accordion, {
            ref: accordElem,
            children: tabNames.map(function (tab, index) {
              var _pastConsumption$cons33, _props$pastUsageParag2, _pastConsumption$cons34, _pastConsumption$cons35;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: (PastUsage_module_default()).accordion,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                    xs: 12,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomToggle, {
                      eventKey: tab.key,
                      className: (PastUsage_module_default())["accordion-title"],
                      children: tab.title
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Accordion.Collapse, {
                  eventKey: tab.key,
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                    className: (PastUsage_module_default())["accordion__collapse border-none"],
                    children: [tab.description, tab.data && tab.data.length > 0 && (tab === null || tab === void 0 ? void 0 : tab.data.map(function (d) {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                        className: "".concat((PastUsage_module_default()).boxes, " ").concat(d.hidden && (PastUsage_module_default())["hide-block"]),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                          children: d.name
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                          className: "".concat((PastUsage_module_default())["data-usage"], " ").concat(d.error && (PastUsage_module_default())["error-warning"]),
                          children: [d.error && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                            className: (PastUsage_module_default())["error-icon"],
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                              src: errorImg,
                              width: 24
                            })
                          }), d.usage]
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "".concat((PastUsage_module_default())["data-des"], " ").concat(d.error && (PastUsage_module_default())["error-warning--des"]),
                          dangerouslySetInnerHTML: {
                            __html: d.des
                          }
                        })]
                      }, d.name);
                    })), tab.overSpend && (pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons33 = pastConsumption.consumption) === null || _pastConsumption$cons33 === void 0 ? void 0 : _pastConsumption$cons33.spendMinusSubsc) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                      className: (PastUsage_module_default())["OverSpend-div"],
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                        className: (PastUsage_module_default())["OverSpend-div__title"],
                        dangerouslySetInnerHTML: {
                          __html: (_props$pastUsageParag2 = props.pastUsageParagraph) === null || _props$pastUsageParag2 === void 0 ? void 0 : _props$pastUsageParag2.heading
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                        className: (PastUsage_module_default())["OverSpend-div__description"],
                        dangerouslySetInnerHTML: {
                          __html: overSpendDescription.replace("[average_monthly_amount]&nbsp;", "<strong>".concat(pastConsumption === null || pastConsumption === void 0 ? void 0 : (_pastConsumption$cons34 = pastConsumption.consumption) === null || _pastConsumption$cons34 === void 0 ? void 0 : (_pastConsumption$cons35 = _pastConsumption$cons34.spendMinusSubsc) === null || _pastConsumption$cons35 === void 0 ? void 0 : _pastConsumption$cons35.toFixed(2), " </strong>"))
                        }
                      })]
                    }) : "", tab.contract_data && tab.contract_data.length > 0 && tab.contract_data.map(function (contract) {
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                          className: (PastUsage_module_default())["contract-type"],
                          children: contract.type
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                          className: (PastUsage_module_default())["details-deal-sub-section"],
                          children: contract.data.map(function (tbl_dt) {
                            return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
                              className: "mx-0 ".concat((PastUsage_module_default())["details-section-row"]),
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                                md: 4 // xs={activeTab == "DESC" ? 6 : 12}
                                ,
                                xs: 6,
                                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
                                  className: "".concat((PastUsage_module_default())["details-label"]),
                                  children: [tbl_dt.label, ":"]
                                })
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                                md: 8 // xs={activeTab == "DESC" ? 6 : 12}
                                ,
                                xs: 6,
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                                  className: (PastUsage_module_default())["details-value"],
                                  children: tbl_dt.value
                                })
                              })]
                            });
                          })
                        })]
                      });
                    })]
                  })
                })]
              }, index);
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (PastUsage_module_default())["section-divider"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          className: "text-center ".concat((PastUsage_module_default())["cta-spacing"]),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
            className: (PastUsage_module_default())["cta-btn"],
            variant: btnConfig.buttonStyle,
            handleClick: goToTop,
            children: btnConfig.buttonLabel
          })
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: isApiError && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (PastUsage_module_default())["error-message"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgUrl,
          width: 15,
          height: 15,
          className: (PastUsage_module_default())["error-image"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "We seem to be having some issues retrieving your past usage  data right now. Please try again later."
        })]
      })
    })]
  });
};

var PastUsage_mapStateToProps = function mapStateToProps(state) {
  return {
    // pastData: state.upgrade.pastUsageData,
    pastConsumptionData: state.upgrade.pastConsumptionData,
    responseToken: state.upgrade.responseToken,
    userLoggedIn: state.navDetails.isUserLoggedIn
  };
};

/* harmony default export */ var PastUsage_PastUsage = ((0,DependencyHelper.connect)(PastUsage_mapStateToProps, {
  getPastUsage: upgradeAction/* getPastUsage */.m5
})(PastUsage));
// EXTERNAL MODULE: ./components/organisms/upgradeBenifits/UpgradeBenifits.module.scss
var UpgradeBenifits_module = __webpack_require__(24644);
var UpgradeBenifits_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeBenifits_module);
;// CONCATENATED MODULE: ./components/organisms/upgradeBenifits/UpgradeBenifits.jsx






var UpgradeBenifits = function UpgradeBenifits(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: (UpgradeBenifits_module_default())["upgrade-benifits"],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
      className: "".concat((UpgradeBenifits_module_default())["upgrade-benifits__row"], " m-0"),
      children: props.simpleCardData.cards.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
          className: (UpgradeBenifits_module_default())["upgrade-benifits__row__col"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: item.image,
              className: (UpgradeBenifits_module_default())["upgrade-benifits__row__col__img"]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (UpgradeBenifits_module_default())["card-title"],
            children: item.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (UpgradeBenifits_module_default())["card-description"],
            dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item.description)
          })]
        });
      })
    })
  });
};

/* harmony default export */ var upgradeBenifits_UpgradeBenifits = (UpgradeBenifits);
// EXTERNAL MODULE: ./components/atoms/dropDown/DropDown.jsx
var DropDown = __webpack_require__(85092);
// EXTERNAL MODULE: ./components/organisms/UpgradeDealsGrid/UpgradeDealsGrid.module.scss
var UpgradeDealsGrid_module = __webpack_require__(83667);
var UpgradeDealsGrid_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeDealsGrid_module);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./components/organisms/UpgradeDealsGrid/UpgradeDealsGrid.jsx


function UpgradeDealsGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function UpgradeDealsGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UpgradeDealsGrid_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UpgradeDealsGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var UpgradeDealsGrid = function UpgradeDealsGrid(props) {
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < 576;
  var financeIndicator = ((0,es/* useSelector */.v9)(function (state) {
    var _state$upgrade, _state$upgrade$credit;

    return (_state$upgrade = state.upgrade) === null || _state$upgrade === void 0 ? void 0 : (_state$upgrade$credit = _state$upgrade.creditFilters) === null || _state$upgrade$credit === void 0 ? void 0 : _state$upgrade$credit.financeIndicator;
  }) || "").toUpperCase();
  var imgUrl = "".concat(imagePrefix, "/assets/images/no-filter-white.svg");
  var getUtagViewData = analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type", "page_site_section_lvl_1", "page_site_section_lvl_2", "upgrade_eligibility_status", "upgrade_eligible_date", "upgrade_customer_type"]);

  var handleProducts = function handleProducts() {
    analyticsUtag/* link */.p4(UpgradeDealsGrid_objectSpread(UpgradeDealsGrid_objectSpread({}, getUtagViewData), {}, {
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getPageName */.j0(), ": browse all products")
    }));
    (0,helperServices/* showSpinner */.yh)();
    DependencyHelper.Router.push('/shopping/products')["finally"](function () {
      window.scrollTo(0, 0);
      (0,helperServices/* hideSpinner */.v3)();
    });
  };

  var handleDeals = function handleDeals() {
    analyticsUtag/* link */.p4(UpgradeDealsGrid_objectSpread(UpgradeDealsGrid_objectSpread({}, getUtagViewData), {}, {
      link_type: "o",
      link_name: "".concat(analyticsUtag/* getPageName */.j0(), ": browse all deals")
    }));
    (0,helperServices/* showSpinner */.yh)();

    if (props.maxLimit) {
      DependencyHelper.Router.push("/shopping/deals/monthly_recurring=minValue:0,maxValue:".concat(props.maxLimit))["finally"](function () {
        window.scrollTo(0, 0);
        (0,helperServices/* hideSpinner */.v3)();
      });
    } else {
      DependencyHelper.Router.push("/shopping/deals")["finally"](function () {
        window.scrollTo(0, 0);
        (0,helperServices/* hideSpinner */.v3)();
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (UpgradeDealsGrid_module_default())["cta-container"],
    children: [!isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (UpgradeDealsGrid_module_default())["cta-text"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeDealsGrid_module_default())["cta-text__icon"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: imgUrl,
          img_width: "60px",
          img_height: "60px",
          id: "xbtn"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (UpgradeDealsGrid_module_default())["cta-heading"],
          children: "Couldn’t find a deal you like?"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (UpgradeDealsGrid_module_default())["cta-description"],
          children: " No problem! You can still find an upgrade deal by browsing the rest of our website."
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (UpgradeDealsGrid_module_default())["cta-list"],
      children: [financeIndicator === "Y" && /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
        variant: isMobile ? "outline black" : "link white",
        handleClick: handleProducts,
        className: (UpgradeDealsGrid_module_default())["cta-products"],
        children: "Browse all products"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
        variant: isMobile ? "outline black" : "solid white",
        handleClick: handleDeals,
        className: (UpgradeDealsGrid_module_default())["cta-deals"],
        children: "Browse all deals I qualify for"
      })]
    })]
  });
};

/* harmony default export */ var UpgradeDealsGrid_UpgradeDealsGrid = (UpgradeDealsGrid);
// EXTERNAL MODULE: ./components/organisms/upgradePageFilters/UpgradePageFilters.module.scss
var UpgradePageFilters_module = __webpack_require__(6115);
var UpgradePageFilters_module_default = /*#__PURE__*/__webpack_require__.n(UpgradePageFilters_module);
;// CONCATENATED MODULE: ./components/organisms/upgradePageFilters/UpgradePageFilters.jsx










var UpgradePageFilters = function UpgradePageFilters(props) {
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var imgUrl = "".concat(imagePrefix, "/assets/images/warning-black.svg");

  var _useState = (0,react.useState)(),
      selectedBrands = _useState[0],
      setSelectedBrands = _useState[1];

  var _useState2 = (0,react.useState)(),
      localModel = _useState2[0],
      setLocalModel = _useState2[1];

  var _useState3 = (0,react.useState)(),
      localContract = _useState3[0],
      setLocalContract = _useState3[1];

  var _useState4 = (0,react.useState)(props === null || props === void 0 ? void 0 : props.selectedContractType),
      contract = _useState4[0],
      setContract = _useState4[1];

  var _useState5 = (0,react.useState)(),
      sortedBrands = _useState5[0],
      setSortedBrands = _useState5[1];

  var handleApply = function handleApply(item) {
    if (item === "brands") {
      props.setSelectedBrand(selectedBrands);
      setLocalModel();
      props.setSelectedModel();
      analyticsUtag/* link */.p4({
        page_tool_event: "use",
        page_tool_name: "shopping: upgrade: recommended deals:brand filter",
        filter_query: selectedBrands
      });
    } else if (item === "model") {
      props.setSelectedModel(localModel);
      analyticsUtag/* link */.p4({
        page_tool_event: "use",
        page_tool_name: "shopping: upgrade: recommended deals:model filter",
        filter_query: localModel
      });
    } else {
      props.setSelectedContractType(localContract);

      if (localContract === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only) {
        props.setSelectedBrand();
        props.setSelectedModel();
        setLocalModel();
        setSelectedBrands();
      }

      analyticsUtag/* link */.p4({
        page_tool_event: "use",
        page_tool_name: "shopping: upgrade: recommended deals:deals filter",
        filter_query: localContract
      });
    }

    document.dispatchEvent(new MouseEvent('click'));
  };

  var handleClear = function handleClear(item) {
    analyticsUtag/* link */.p4({
      page_tool_event: "use",
      page_tool_name: "shopping: upgrade: recommended deals:remove ".concat(item === "contract " ? "deals" : item, " filter")
    });

    switch (item) {
      case "brands":
        props.setSelectedBrand();
        setSelectedBrands();
        break;

      case "model":
        setLocalModel();
        props.setSelectedModel();
        break;

      default:
        setLocalModel();
        props.setSelectedModel();
        setSelectedBrands();
        props.setSelectedBrand();
        setLocalContract();
        setContract();
        props.setSelectedContractType();
    }

    document.dispatchEvent(new MouseEvent('click'));
  };

  var handleContract = function handleContract(item) {
    setContract(item);

    if (item === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only) {
      setSelectedBrands();
    }

    setLocalContract(item);
  };

  var handleDisable = function handleDisable() {
    return !(props.selectedBrand || props.selectedModel || props.selectedContractType);
  };

  var handleSearchDeals = function handleSearchDeals() {
    //Magento API to be called
    props.searchDeals();
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "shopping: upgrade: recommended deals: search deals"
    });
  };

  var truncateString = function truncateString(str, stringLen) {
    return str.length > stringLen ? str.substring(0, stringLen) + "..." : str;
  };

  (0,react.useEffect)(function () {
    if (!props.brands) {
      analyticsUtag/* link */.p4({
        page_name: "shopping: upgrade: recommended deals",
        page_form_event: "error",
        page_errors: "We seem to be having some issues loading filters  right now. Please try again later.",
        page_error_type: "page"
      });
    } else {
      var _props$brands;

      setSortedBrands(props === null || props === void 0 ? void 0 : (_props$brands = props.brands) === null || _props$brands === void 0 ? void 0 : _props$brands.sort(function (a, b) {
        return a.localeCompare(b);
      }));
    }
  }, [props.brands]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: (UpgradePageFilters_module_default())["just-heading"],
      children: "Just4You deals"
    }), props.brands && props.brands.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
        md: 10,
        lg: 10,
        className: "px-0 ".concat((UpgradePageFilters_module_default())["left-filters"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
          className: "mx-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
            md: 4,
            lg: 4,
            className: "pr-ss ".concat((UpgradePageFilters_module_default())["dropdown-container"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (UpgradePageFilters_module_default())["contract-heading"],
              children: labels/* default.upgrade.planData.lbl_looking_for */.Z.upgrade.planData.lbl_looking_for
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.DropdownButton, {
              title: contract ? contract : "-Select-",
              className: (UpgradePageFilters_module_default())["drop-down"],
              bsPrefix: (UpgradePageFilters_module_default())["upgrade-drop-down"],
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["model-heading"],
                  children: "Which kind of contract would you like?"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["model-options"],
                  children: props.planData && props.planData.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                      className: "".concat((UpgradePageFilters_module_default()).options, " ").concat(localContract == item && (UpgradePageFilters_module_default())["active-option"]),
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                        htmlFor: item,
                        onClick: function onClick() {
                          return handleContract(item);
                        },
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                          type: "radio",
                          value: item,
                          name: "contract",
                          id: item,
                          checked: contract === item
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: (UpgradePageFilters_module_default())["option-text"],
                          children: item
                        })]
                      })
                    }, "planData_".concat(index));
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["modal-apply"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
                    variant: "outline grey",
                    className: "".concat((UpgradePageFilters_module_default())["clear-btn"], " ").concat(!contract && (UpgradePageFilters_module_default())["disabled-clear"]),
                    handleClick: function handleClick() {
                      return handleClear("contract");
                    },
                    children: "Reset"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
                    variant: "solid grey",
                    className: "".concat((UpgradePageFilters_module_default())["clear-btn"], " ").concat(!contract && (UpgradePageFilters_module_default())["disabled-modal"], "  ").concat((UpgradePageFilters_module_default()).white),
                    handleClick: function handleClick() {
                      return handleApply("contract");
                    },
                    children: "Apply"
                  })]
                })]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
            md: 4,
            lg: 4,
            className: "pl-ss pr-ss ".concat(props.selectedContractType === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only || !contract ? (UpgradePageFilters_module_default()).disabled : "", " ").concat((UpgradePageFilters_module_default())["dropdown-container"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (UpgradePageFilters_module_default())["contract-heading"],
              children: "Brand"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.DropdownButton, {
              title: props.selectedBrand ? props.selectedBrand : "-Select-",
              bsPrefix: "".concat((UpgradePageFilters_module_default())["upgrade-drop-down"], " ").concat(!props.selectedBrand ? (UpgradePageFilters_module_default())["dropdown-text"] : ""),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: (UpgradePageFilters_module_default())["brands-modal"],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["model-heading"],
                  children: "Which brand do you prefer?"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["model-options"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
                    className: "".concat((UpgradePageFilters_module_default())["brand-container"]),
                    children: props.brands && sortedBrands && sortedBrands.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                        md: 3,
                        lg: 3,
                        className: "".concat((UpgradePageFilters_module_default()).options, " ").concat(selectedBrands == item && (UpgradePageFilters_module_default())["active-option"]),
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                          htmlFor: item,
                          onClick: function onClick() {
                            return setSelectedBrands(item);
                          },
                          className: (UpgradePageFilters_module_default())["brand-label"],
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            value: item,
                            name: "brand",
                            id: item,
                            checked: selectedBrands == item,
                            className: (UpgradePageFilters_module_default())["brand-radio"]
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: (UpgradePageFilters_module_default())["option-text"],
                            children: item
                          })]
                        })
                      }, "brandData_".concat(index));
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["modal-apply"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
                    variant: "outline grey",
                    className: "".concat((UpgradePageFilters_module_default())["clear-btn"], " ").concat(!selectedBrands && (UpgradePageFilters_module_default())["disabled-clear"]),
                    handleClick: function handleClick() {
                      return handleClear("brands");
                    },
                    children: "Clear"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
                    variant: "solid grey",
                    className: "".concat((UpgradePageFilters_module_default())["clear-btn"], " ").concat(!selectedBrands ? (UpgradePageFilters_module_default())["disabled-modal"] : "", "  ").concat((UpgradePageFilters_module_default()).white),
                    handleClick: function handleClick() {
                      return handleApply("brands");
                    },
                    children: "Apply"
                  })]
                })]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
            md: 4,
            lg: 4,
            className: " pl-ss pr-ss ".concat(props.selectedBrand ? (UpgradePageFilters_module_default()).model : (UpgradePageFilters_module_default()).disabled, " ").concat((UpgradePageFilters_module_default())["dropdown-container"]),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: (UpgradePageFilters_module_default())["contract-heading"],
              children: "Model"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.DropdownButton, {
              title: props.selectedModel ? props.selectedModel : "-Select-",
              bsPrefix: "".concat((UpgradePageFilters_module_default())["upgrade-drop-down"], "  ").concat(!props.selectedModel ? (UpgradePageFilters_module_default())["dropdown-text"] : ""),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: props.models.length >= 60 ? (UpgradePageFilters_module_default())["brands-modal-large-list"] : (UpgradePageFilters_module_default())["brands-modal"],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["model-heading"],
                  children: "Which ".concat(props.selectedBrand, " model are you looking for?")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["model-options"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
                    children: props.models && props.models.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                        md: 6,
                        lg: 6,
                        className: "".concat((UpgradePageFilters_module_default()).options, " ").concat(localModel == item && (UpgradePageFilters_module_default())["active-option"]),
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                          htmlFor: item,
                          onClick: function onClick() {
                            return setLocalModel(item);
                          },
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            value: item,
                            name: "model",
                            id: item,
                            checked: localModel == item
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: (UpgradePageFilters_module_default())["option-text"],
                            children: props.models.length >= 60 ? truncateString(item, 55) : truncateString(item, 25)
                          })]
                        })
                      }, "modelData_".concat(index));
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (UpgradePageFilters_module_default())["modal-apply"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
                    variant: "outline grey",
                    className: "".concat((UpgradePageFilters_module_default())["clear-btn"], " ").concat(!localModel && (UpgradePageFilters_module_default())["disabled-clear"]),
                    handleClick: function handleClick() {
                      return handleClear("model");
                    },
                    children: "Clear"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
                    variant: "solid grey",
                    className: "".concat((UpgradePageFilters_module_default())["clear-btn"], " ").concat(!localModel && (UpgradePageFilters_module_default())["disabled-modal"], " ").concat((UpgradePageFilters_module_default()).white),
                    handleClick: function handleClick() {
                      return handleApply("model");
                    },
                    children: "Apply"
                  })]
                })]
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        md: 2,
        lg: 2,
        className: "pl-ss ".concat((UpgradePageFilters_module_default())["right-filter"]),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "".concat((UpgradePageFilters_module_default())["contract-heading"], " ").concat((UpgradePageFilters_module_default())["hide-btn"], "  "),
          children: "show-deal"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton_CTAButton["default"], {
          variant: "solid grey",
          handleClick: handleSearchDeals,
          disabled: handleDisable(),
          className: "".concat((UpgradePageFilters_module_default())["deals-btn"], " ").concat(handleDisable() ? (UpgradePageFilters_module_default()).disabled : ""),
          children: "Search deals"
        })]
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (UpgradePageFilters_module_default())["error-message"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: imgUrl,
        width: 18,
        height: 18,
        className: (UpgradePageFilters_module_default())["error-message-icon"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "We seem to be having some issues loading filters right now. Please try again later."
      })]
    })]
  });
};

/* harmony default export */ var upgradePageFilters_UpgradePageFilters = (UpgradePageFilters);
// EXTERNAL MODULE: ./components/organisms/upgradeDealsPageContainer/UpgradeDealsPageContainer.module.scss
var UpgradeDealsPageContainer_module = __webpack_require__(48330);
var UpgradeDealsPageContainer_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeDealsPageContainer_module);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./components/atoms/button/ButtonComponent.js + 1 modules
var ButtonComponent = __webpack_require__(33757);
// EXTERNAL MODULE: ./components/molecules/UpgradeInfoBanner/UpgradeInfoBanner.module.scss
var UpgradeInfoBanner_module = __webpack_require__(62056);
var UpgradeInfoBanner_module_default = /*#__PURE__*/__webpack_require__.n(UpgradeInfoBanner_module);
// EXTERNAL MODULE: ./components/atoms/upgradeDropdown/UpgradeDropdown.jsx + 1 modules
var UpgradeDropdown = __webpack_require__(51969);
;// CONCATENATED MODULE: ./components/molecules/UpgradeInfoBanner/UpgradeInfoBanner.jsx
















var UpgradeInfoBanner = function UpgradeInfoBanner(props) {
  var _props$allUpgradesDat, _props$displayData, _props$tempDisplayDat, _props$tempUpgradeRes4, _props$tempUpgradeRes5, _props$displayData2, _props$tempUpgradeRes6;

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var windowSize = (0,helperServices/* componentCheckSize */.Qj)();
  var isMobile = windowSize < constants/* MOBILE_WIDTH */.P_;
  var infoClass = props !== null && props !== void 0 && props.infoBold ? (UpgradeInfoBanner_module_default())["upgrade-banner-info-bold"] : (UpgradeInfoBanner_module_default())["upgrade-banner-info"];
  var defaultData = props === null || props === void 0 ? void 0 : (_props$allUpgradesDat = props.allUpgradesData) === null || _props$allUpgradesDat === void 0 ? void 0 : _props$allUpgradesDat.filter(function (item) {
    return (0,upgradeService/* maskMsisdn */.Ly)(item.msisdn) == (0,upgradeService/* maskMsisdn */.Ly)(props.selectedNumber);
  });

  var _useState = (0,react.useState)(defaultData[0]),
      selectedItem = _useState[0],
      setSelectedItem = _useState[1];

  var _useState2 = (0,react.useState)(),
      linkedNum = _useState2[0],
      setLinkedNum = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      showBanner = _useState3[0],
      setShowBanner = _useState3[1];

  var _useState4 = (0,react.useState)(defaultData[0]),
      nextSelectedData = _useState4[0],
      setNextSelectedData = _useState4[1];

  (0,react.useEffect)(function () {
    var _selectedItem$resultC;

    if ((0,upgradeService/* checkifUpgradableAndC3D */.Yo)(selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem$resultC = selectedItem.resultCode) === null || _selectedItem$resultC === void 0 ? void 0 : _selectedItem$resultC.toLowerCase())) {
      props.fetchCreditFilters(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.msisdn);
    }
  }, [selectedItem]);

  var scrollToTop = function scrollToTop() {
    // scrolling the window up when closing the modal
    if (isMobile && showBanner) window.scrollTo(0, 0);
  };

  var handleBtnClick = function handleBtnClick(data) {
    var _data$resultCode;

    var showModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    // props.handleBtnClick(data);
    if (data.mah && (0,upgradeService/* checkifUpgradableAndC3D */.Yo)(data === null || data === void 0 ? void 0 : (_data$resultCode = data.resultCode) === null || _data$resultCode === void 0 ? void 0 : _data$resultCode.toLowerCase())) {
      props.updateData(data);
      props.updateSelectedData(data);
    } else {
      props.updateData(data);
      props.displayHideUpgradeModal(showModal);
    }

    setSelectedItem(data); //setNextSelectedData(data);

    props.setSelectedNumber(data === null || data === void 0 ? void 0 : data.msisdn); // props.setSelectedAlternative(data);
    // if (!data.mah || !checkifUpgradableAndC3D(data?.resultCode?.toLowerCase())) {
    //   props.displayHideUpgradeModal(!props.showUpgradeModal)
    // }
    // props.updateSelectedData(data);
  };

  var handleDropdownSelect = function handleDropdownSelect(num, showModal) {
    var _props$allUpgradesDat2;

    var selData = props === null || props === void 0 ? void 0 : (_props$allUpgradesDat2 = props.allUpgradesData) === null || _props$allUpgradesDat2 === void 0 ? void 0 : _props$allUpgradesDat2.filter(function (item) {
      return item.msisdn == num;
    });
    handleBtnClick(selData[0], showModal);
  };

  var handleCTABtnClick = function handleCTABtnClick(item) {
    scrollToTop();
    setShowBanner(!showBanner);
    props.updateSelectedData(item);
  };

  var toggleModal = function toggleModal() {
    scrollToTop();
    setShowBanner(!showBanner);
  };

  var InfoTextBox = function InfoTextBox(_ref) {
    var _upgradeResponse$resu, _upgradeResponse$resu2, _props$allUpgradesDat3, _props$allUpgradesDat4;

    var inModal = _ref.inModal;
    var upgradeResponse = inModal ? props.tempUpgradeResponse : props.upgradeResponse;
    var displayData = inModal ? props.tempDisplayData : props.upgradeResponse;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeInfoBanner_module_default())["upgrade-banner-main-text"],
        children: inModal ? displayData === null || displayData === void 0 ? void 0 : displayData.resultTitle : "Yes! You can upgrade right now!"
      }), (0,upgradeService/* checkifUpgradableAndC3D */.Yo)(upgradeResponse === null || upgradeResponse === void 0 ? void 0 : (_upgradeResponse$resu = upgradeResponse.resultCode) === null || _upgradeResponse$resu === void 0 ? void 0 : _upgradeResponse$resu.toLowerCase()) ? labels/* default.upgrade.lbl_scroll_desc */.Z.upgrade.lbl_scroll_desc : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeInfoBanner_module_default())["upgrade-banner-sub-text"],
        dangerouslySetInnerHTML: {
          __html: displayData !== null && displayData !== void 0 && displayData.resultHTML ? displayData === null || displayData === void 0 ? void 0 : displayData.resultHTML : (displayData === null || displayData === void 0 ? void 0 : displayData.resultText) || ""
        }
      }), !(0,upgradeService/* checkifUpgradableAndC3D */.Yo)(upgradeResponse === null || upgradeResponse === void 0 ? void 0 : (_upgradeResponse$resu2 = upgradeResponse.resultCode) === null || _upgradeResponse$resu2 === void 0 ? void 0 : _upgradeResponse$resu2.toLowerCase()) && (upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeInfoBanner_module_default())["info-text"],
        children: upgradeResponse === null || upgradeResponse === void 0 ? void 0 : upgradeResponse.upgradeDate
      }), (props === null || props === void 0 ? void 0 : props.allUpgradesData) && (props === null || props === void 0 ? void 0 : (_props$allUpgradesDat3 = props.allUpgradesData) === null || _props$allUpgradesDat3 === void 0 ? void 0 : _props$allUpgradesDat3.length) == 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: infoClass,
          children: "This is the number you can upgrade right now:"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (UpgradeInfoBanner_module_default())["info-label"],
          children: (0,upgradeService/* maskMsisdn */.Ly)(props.allUpgradesData[0].msisdn)
        })]
      }), (props === null || props === void 0 ? void 0 : props.allUpgradesData) && (props === null || props === void 0 ? void 0 : (_props$allUpgradesDat4 = props.allUpgradesData) === null || _props$allUpgradesDat4 === void 0 ? void 0 : _props$allUpgradesDat4.length) > 1 && upgradeResponse.upgradeEligible && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: windowSize > constants/* MOBILE_WIDTH */.P_ ? (UpgradeInfoBanner_module_default())["upgrade-banner-info-bold"] : (UpgradeInfoBanner_module_default())["upgrade-banner-info"],
          children: ["You've got more than one upgradeable number! ", /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: " Which one would you like to upgrade?"
          })]
        })
      })]
    });
  };

  var Selections = function Selections(_ref2) {
    var _props$upgradeRespons4, _props$upgradeRespons5, _props$upgradeRespons6, _props$upgradeRespons7;

    var sizeType = _ref2.sizeType,
        _ref2$showModal = _ref2.showModal,
        showModal = _ref2$showModal === void 0 ? true : _ref2$showModal;
    var upperLimit = 0;

    if (sizeType == "desktop") {
      upperLimit = 4;
    } else if (sizeType == "tablet" || sizeType == "mobile") {
      upperLimit = 3;
    }

    var msisdnsList = props.allUpgradesData.map(function (item, index) {
      return {
        num: item.msisdn,
        id: index + 1,
        label: item.upgradeEligible ? "".concat((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), " (Upgradeable)") : "".concat((0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), " (Not upgradeable)")
      };
    });

    var handleDropdownVal = function handleDropdownVal(val) {
      msisdnsList.forEach(function (item) {
        if (item.label === val) {
          handleDropdownSelect(item.num, showModal);
        }
      });
    };

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [props.allUpgradesData && props.allUpgradesData.length >= 2 && props.allUpgradesData.length <= upperLimit && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (UpgradeInfoBanner_module_default())["button-container"],
        children: props.allUpgradesData.map(function (item, idx) {
          var _props$upgradeRespons, _props$tempUpgradeRes, _props$upgradeRespons2, _props$tempUpgradeRes2;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, {
            className: "".concat((showModal ? ((_props$upgradeRespons = props.upgradeResponse) === null || _props$upgradeRespons === void 0 ? void 0 : _props$upgradeRespons.msisdn) === (item === null || item === void 0 ? void 0 : item.msisdn) : ((_props$tempUpgradeRes = props.tempUpgradeResponse) === null || _props$tempUpgradeRes === void 0 ? void 0 : _props$tempUpgradeRes.msisdn) === (item === null || item === void 0 ? void 0 : item.msisdn)) ? (UpgradeInfoBanner_module_default())["button-selected"] : (UpgradeInfoBanner_module_default()).button, " ").concat(!item.upgradeEligible ? (UpgradeInfoBanner_module_default())["button-disabled"] : ""),
            textClassName: (showModal ? ((_props$upgradeRespons2 = props.upgradeResponse) === null || _props$upgradeRespons2 === void 0 ? void 0 : _props$upgradeRespons2.msisdn) === (item === null || item === void 0 ? void 0 : item.msisdn) : ((_props$tempUpgradeRes2 = props.tempUpgradeResponse) === null || _props$tempUpgradeRes2 === void 0 ? void 0 : _props$tempUpgradeRes2.msisdn) === (item === null || item === void 0 ? void 0 : item.msisdn)) ? (UpgradeInfoBanner_module_default())["button-selected-text"] : (UpgradeInfoBanner_module_default())["button-text"],
            text: (0,upgradeService/* maskMsisdn */.Ly)(item.msisdn),
            onBtnClick: function onBtnClick() {
              return handleBtnClick(item, showModal);
            }
          }, "btn_" + idx);
        })
      }), props.allUpgradesData && props.allUpgradesData.length > upperLimit && (isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
        className: (UpgradeInfoBanner_module_default())["upgrade-select"],
        onChange: function onChange(event) {
          return handleDropdownSelect(event.target.value, showModal);
        },
        children: props.allUpgradesData && props.allUpgradesData.map(function (item, index) {
          var _props$upgradeRespons3, _props$tempUpgradeRes3;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("option", {
            selected: (showModal ? ((_props$upgradeRespons3 = props.upgradeResponse) === null || _props$upgradeRespons3 === void 0 ? void 0 : _props$upgradeRespons3.msisdn) === (item === null || item === void 0 ? void 0 : item.msisdn) : ((_props$tempUpgradeRes3 = props.tempUpgradeResponse) === null || _props$tempUpgradeRes3 === void 0 ? void 0 : _props$tempUpgradeRes3.msisdn) === (item === null || item === void 0 ? void 0 : item.msisdn)) ? "selected" : "",
            value: item.msisdn,
            children: [(0,upgradeService/* maskMsisdn */.Ly)(item.msisdn), "(".concat(item !== null && item !== void 0 && item.upgradeEligible ? "Upgradeable" : "Not upgradeable", ")")]
          }, index);
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeDropdown/* default */.Z, {
        selectedValue: showModal ? "".concat((0,upgradeService/* maskMsisdn */.Ly)((_props$upgradeRespons4 = props.upgradeResponse) === null || _props$upgradeRespons4 === void 0 ? void 0 : _props$upgradeRespons4.msisdn), " ").concat((_props$upgradeRespons5 = props.upgradeResponse) !== null && _props$upgradeRespons5 !== void 0 && _props$upgradeRespons5.upgradeEligible ? "(Upgradeable)" : "(Not upgradeable)") : "".concat((0,upgradeService/* maskMsisdn */.Ly)((_props$upgradeRespons6 = props.upgradeResponse) === null || _props$upgradeRespons6 === void 0 ? void 0 : _props$upgradeRespons6.msisdn), " ").concat((_props$upgradeRespons7 = props.upgradeResponse) !== null && _props$upgradeRespons7 !== void 0 && _props$upgradeRespons7.upgradeEligible ? "(Upgradeable)" : "(Not upgradeable)"),
        optionsList: msisdnsList,
        handleSelect: handleDropdownVal,
        showIcon: true
      }))]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showBanner && windowSize >= constants/* MOBILE_WIDTH */.P_ && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          md: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (UpgradeInfoBanner_module_default())["upgrade-banner-wrapper"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              className: (UpgradeInfoBanner_module_default())["upgrade-banner-mark"],
              img_path: props === null || props === void 0 ? void 0 : (_props$displayData = props.displayData) === null || _props$displayData === void 0 ? void 0 : _props$displayData.icon,
              alt: "banner-mark"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoTextBox, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "d-none d-lg-block mt-m",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Selections, {
                sizeType: "desktop"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "d-none d-md-block d-lg-none d-sm-block mt-m",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Selections, {
                sizeType: "tablet"
              })
            })]
          })
        })
      })
    }), showBanner && isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal, {
      show: showBanner,
      dialogClassName: " select-modal ".concat((UpgradeInfoBanner_module_default())["upgrade-banner-wrapper-modal"]),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal.Header, {
        className: (UpgradeInfoBanner_module_default())["modal-header"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          className: (UpgradeInfoBanner_module_default())["close-button"],
          img_path: "".concat(imagePrefix, "/assets/images/close-black.svg"),
          alt: "close",
          onClick: toggleModal
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Body, {
        className: (UpgradeInfoBanner_module_default())["modal-body"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          style: {
            textAlign: "center"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            className: (UpgradeInfoBanner_module_default())["upgrade-banner-mark-modal"],
            img_path: props === null || props === void 0 ? void 0 : (_props$tempDisplayDat = props.tempDisplayData) === null || _props$tempDisplayDat === void 0 ? void 0 : _props$tempDisplayDat.icon,
            alt: "banner-mark"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(InfoTextBox, {
          inModal: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Selections, {
          sizeType: "mobile",
          showModal: false
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (UpgradeInfoBanner_module_default())["button-container"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, {
            className: props !== null && props !== void 0 && (_props$tempUpgradeRes4 = props.tempUpgradeResponse) !== null && _props$tempUpgradeRes4 !== void 0 && _props$tempUpgradeRes4.upgradeEligible ? (UpgradeInfoBanner_module_default())["cta-button"] : (UpgradeInfoBanner_module_default())["cta-button-disabled"],
            textClassName: props !== null && props !== void 0 && (_props$tempUpgradeRes5 = props.tempUpgradeResponse) !== null && _props$tempUpgradeRes5 !== void 0 && _props$tempUpgradeRes5.upgradeEligible ? (UpgradeInfoBanner_module_default())["cta-button-text"] : (UpgradeInfoBanner_module_default())["cta-button-text-disabled"],
            text: props.allUpgradesData.length > 1 ? labels/* default.upgrade.lbl_upgrade_number */.Z.upgrade.lbl_upgrade_number : props === null || props === void 0 ? void 0 : (_props$displayData2 = props.displayData) === null || _props$displayData2 === void 0 ? void 0 : _props$displayData2.primaryCTAText,
            disabledFlag: !(props !== null && props !== void 0 && (_props$tempUpgradeRes6 = props.tempUpgradeResponse) !== null && _props$tempUpgradeRes6 !== void 0 && _props$tempUpgradeRes6.upgradeEligible),
            onBtnClick: function onBtnClick() {
              return handleCTABtnClick(selectedItem);
            }
          })
        })]
      })]
    })]
  });
};

var UpgradeInfoBanner_mapStateToProps = function mapStateToProps(state) {
  return {
    showUpgradeModal: state.upgrade.showModal,
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    upgradeResponse: state.upgrade.selectedUpgradeResponse,
    displayData: state.upgrade.selectedUpgradeDisplayData,
    tempDisplayData: state.upgrade.upgradeDisplayData,
    tempUpgradeResponse: state.upgrade.upgradeResponse,
    linkedNumbers: state.upgrade.linkedNumbers,
    allUpgradesData: state.upgrade.allUpgradesData,
    isNextMsisdnSelected: state.upgrade.isNextMsisdnSelected,
    msisdn: state.upgrade.msisdn
  };
};

/* harmony default export */ var UpgradeInfoBanner_UpgradeInfoBanner = ((0,DependencyHelper.connect)(UpgradeInfoBanner_mapStateToProps, {
  fetchAlternateNumbers: upgradeAction/* fetchAlternateNumbers */.CC,
  updateSelectedData: upgradeAction/* updateSelectedData */.x$,
  updateData: upgradeAction/* updateData */.VA,
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  fetchCreditFilters: upgradeAction/* fetchCreditFilters */.QV,
  updatedNextMsisdnSelected: upgradeAction/* updatedNextMsisdnSelected */.Op
})(UpgradeInfoBanner));
// EXTERNAL MODULE: ./components/atoms/whitePill/WhitePill.jsx
var WhitePill = __webpack_require__(53803);
;// CONCATENATED MODULE: ./components/organisms/upgradeDealsPageContainer/UpgradeDealsPageContainer.jsx























var UpgradeDealsPageContainer = function UpgradeDealsPageContainer(props) {
  var _props$productList3, _props$productList3$p, _props$productList4, _props$productList4$p, _props$productList4$p2, _props$productList5, _props$productList5$p, _props$productList6, _props$productList6$p, _props$productList7, _props$productList7$p;

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var imgUrl = "".concat(imagePrefix, "/assets/images/warning-black.svg");
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() < 992;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < constants/* MOBILE_WIDTH */.P_;

  var _useState = (0,react.useState)(false),
      showSnackBar = _useState[0],
      setShowSnackBar = _useState[1];

  var _useState2 = (0,react.useState)(),
      selectedAlternative = _useState2[0],
      setSelectedAlternative = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isApiError = _useState3[0],
      setIsApiError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isRemovePill = _useState4[0],
      setIsRemovePill = _useState4[1];

  var sectionReference = (0,react.useRef)(null);

  var OnClickScrollViewElement = function OnClickScrollViewElement() {
    if (sectionReference.current) {
      if (isMobile) {
        sectionReference.current.scrollIntoView(true);
      }
    }
  }; //saved for testing purposes


  var testData = {
    mainText: "Yes! You can upgrade right now.",
    subText: "The wait is finally over! Scroll down to choose the perfect deal for you",
    bannerInfo: "This is the number you can upgrade right now",
    imagePath: "http://localhost:1434/assets/images/close-black.svg",
    msisdn: [{
      label: "143445254",
      upgradeable: true
    }, {
      label: "999999999",
      upgradeable: true
    }, {
      label: "333333333",
      upgradeable: true
    }, {
      label: "444444444",
      upgradeable: true
    }, {
      label: "444444444",
      upgradeable: true
    }]
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar(false);
  };

  (0,react.useEffect)(function () {
    var _props$dealSkus, _props$productList, _props$productList$pr;

    if (((_props$dealSkus = props.dealSkus) === null || _props$dealSkus === void 0 ? void 0 : _props$dealSkus.length) == 0 && props.loadingProducts && !(props !== null && props !== void 0 && props.productList)) {
      setShowSnackBar(true);
      setIsApiError(true);
    }

    if (!props.loadingProducts && props !== null && props !== void 0 && (_props$productList = props.productList) !== null && _props$productList !== void 0 && (_props$productList$pr = _props$productList.products) !== null && _props$productList$pr !== void 0 && _props$productList$pr.items) {
      var _props$productList2, _props$productList2$p, _props$productList2$p2;

      if (props !== null && props !== void 0 && (_props$productList2 = props.productList) !== null && _props$productList2 !== void 0 && (_props$productList2$p = _props$productList2.products) !== null && _props$productList2$p !== void 0 && (_props$productList2$p2 = _props$productList2$p.items) !== null && _props$productList2$p2 !== void 0 && _props$productList2$p2.length) {
        setShowSnackBar(false);
        setIsApiError(false);
      } else {
        setShowSnackBar(true);
        analyticsUtag/* link */.p4({
          page_name: "shopping: upgrade: recommended deals",
          page_form_event: "error",
          page_errors: "We seem to be having some issues retrieving your recommended deals right now. Please try again later.",
          page_error_type: "page"
        });
        setIsApiError(true);
      }
    }
  }, [props === null || props === void 0 ? void 0 : (_props$productList3 = props.productList) === null || _props$productList3 === void 0 ? void 0 : (_props$productList3$p = _props$productList3.products) === null || _props$productList3$p === void 0 ? void 0 : _props$productList3$p.items, props.loadingProducts]);

  var _useState5 = (0,react.useState)("Recommended deals"),
      activeTab = _useState5[0],
      setActiveTab = _useState5[1];

  var tabsToRender = [{
    key: 1,
    title: "Recommended deals",
    component: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "heading-and-filter-button-container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            xs: 12,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (UpgradeDealsPageContainer_module_default())["heading-and-filter-button-wrapper"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: (UpgradeDealsPageContainer_module_default())["just-heading"],
                children: "Just4You deals"
              }), !props.dealApiError && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: (UpgradeDealsPageContainer_module_default())["filters-modal-button"],
                onClick: function onClick() {
                  return props.setShowModal(true);
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  className: (UpgradeDealsPageContainer_module_default())["button-image"],
                  height: 24,
                  src: "".concat(imagePrefix, "/assets/images/filter.svg"),
                  alt: "filter"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: (UpgradeDealsPageContainer_module_default())["button-label"],
                  children: "Filter deals"
                })]
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [!isTablet && !props.dealApiError && /*#__PURE__*/(0,jsx_runtime.jsx)(upgradePageFilters_UpgradePageFilters, {
          setSelectedContractType: props.setSelectedContractType,
          setSelectedBrand: props.setSelectedBrand,
          setSelectedModel: props.setSelectedModel,
          selectedContractType: props.selectedContractType,
          selectedBrand: props.selectedBrand,
          selectedModel: props.selectedModel,
          brands: props.brands,
          models: props.models,
          planData: props.planData,
          searchDeals: props.searchDeals
        }), (isMobile || isTablet) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [props.isContractTypeFilterApplied && props.selectedContractType && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
            style: {
              marginRight: "0.5rem",
              marginTop: "0.5rem"
            },
            name: props.selectedContractType,
            removeBtnHandler: function removeBtnHandler() {
              return removeFilter("contractType");
            }
          }), props.isBrandFilterApplied && props.selectedBrand && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
            style: {
              marginRight: "0.5rem",
              marginTop: "0.5rem"
            },
            name: props.selectedBrand,
            removeBtnHandler: function removeBtnHandler() {
              return removeFilter("brand");
            }
          }), props.isModelFilterApplied && props.selectedModel && /*#__PURE__*/(0,jsx_runtime.jsx)(WhitePill/* default */.Z, {
            style: {
              marginRight: "0.5rem",
              marginTop: "0.5rem"
            },
            name: props.selectedModel,
            removeBtnHandler: function removeBtnHandler() {
              return removeFilter("model");
            }
          })]
        }), (props === null || props === void 0 ? void 0 : (_props$productList4 = props.productList) === null || _props$productList4 === void 0 ? void 0 : (_props$productList4$p = _props$productList4.products) === null || _props$productList4$p === void 0 ? void 0 : (_props$productList4$p2 = _props$productList4$p.items) === null || _props$productList4$p2 === void 0 ? void 0 : _props$productList4$p2.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "deal-cards-container",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
              lg: 12,
              xl: 12,
              className: isTablet ? "pb-5" : "pl-2",
              ref: sectionReference,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DealListContainer["default"], {
                setActiveTab: setActiveTab,
                items: (_props$productList5 = props.productList) === null || _props$productList5 === void 0 ? void 0 : (_props$productList5$p = _props$productList5.products) === null || _props$productList5$p === void 0 ? void 0 : _props$productList5$p.items,
                isDealGridPage: false,
                sortBy: props.setSortBy,
                pageInfo: (_props$productList6 = props.productList) === null || _props$productList6 === void 0 ? void 0 : (_props$productList6$p = _props$productList6.products) === null || _props$productList6$p === void 0 ? void 0 : _props$productList6$p.page_info,
                updateCurrentPage: props.updateCurrentPage,
                totalItemsCount: (_props$productList7 = props.productList) === null || _props$productList7 === void 0 ? void 0 : (_props$productList7$p = _props$productList7.products) === null || _props$productList7$p === void 0 ? void 0 : _props$productList7$p.total_count,
                selectedSortVal: props.sortBy,
                spanXl: "3",
                dealButtonTxt: labels/* default.lbl_deal_selection_page_card_btn */.Z.lbl_deal_selection_page_card_btn,
                isDealSelection: true,
                isDSE: true,
                pageName: "upgrade",
                resetDealSelectionFilter: props.resetFilter,
                analyticsHandleSortFilter: props.analyticsHandleSortFilter,
                OnClickScrollViewElement: OnClickScrollViewElement,
                upgradeCheckDone: true,
                showFiltersModal: props.setShowModal
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeDealsGrid_UpgradeDealsGrid, {})]
            })
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [isApiError && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (UpgradeDealsPageContainer_module_default())["error-message"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: imgUrl,
              width: 17,
              height: 17,
              className: (UpgradeDealsPageContainer_module_default())["error-image"]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: [" ", "We seem to be having some issues retrieving your recommended deals right now. Please try again later."]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (UpgradeDealsPageContainer_module_default())["button-container"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeDealsGrid_UpgradeDealsGrid, {})
          })]
        })]
      })]
    })
  }, {
    key: 2,
    title: "Past usage & spend",
    component: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      className: (UpgradeDealsPageContainer_module_default())["pastusage-container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PastUsage_PastUsage, {
        selectedNumber: props.selectedNumber,
        setSelectedNumber: props.setSelectedNumber,
        pastUsageParagraph: props.pastUsageParagraph,
        setActiveTab: setActiveTab
      })
    })
  }, !isTablet && {
    key: 3,
    title: "Why upgrade online ?",
    component: props.simpleCardData && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      className: (UpgradeDealsPageContainer_module_default())["benifits-container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeBenifits_UpgradeBenifits, {
        simpleCardData: props.simpleCardData
      })
    })
  }];
  (0,react.useEffect)(function () {
    if (isRemovePill) {
      props.searchDeals();
      setIsRemovePill(false);
    }
  }, [isRemovePill]);

  var removeFilter = function removeFilter(filterType) {
    switch (filterType) {
      case "contractType":
        props.setSelectedContractType("");
        props.setSelectedBrand();
        props.setSelectedModel();
        break;

      case "brand":
        props.setSelectedBrand();
        break;

      case "model":
        props.setSelectedModel();
        break;

      default:
        break;
    }

    setIsRemovePill(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
    className: (UpgradeDealsPageContainer_module_default())["dse-container"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeInfoBanner_UpgradeInfoBanner, {
      data: testData,
      infoBold: false,
      selectedNumber: props.selectedNumber,
      setSelectedNumber: props.setSelectedNumber
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTabs/* default */.Z, {
      tabsContent: tabsToRender,
      variant: "black-with-line",
      tabType: "tab",
      alignment: "left",
      analytics: {
        link_name: "shopping: upgrade: recommended deals:"
      },
      selectedTab: activeTab,
      selectTabHandler: setActiveTab,
      page: "upgrade"
    })]
  });
};

var UpgradeDealsPageContainer_mapStateToProps = function mapStateToProps(state) {
  return {
    showUpgradeModal: state.upgrade.showModal,
    allUpgradesData: state.upgrade.allUpgradesData,
    upgradeResponse: state.upgrade.selectedUpgradeResponse
  };
};

/* harmony default export */ var upgradeDealsPageContainer_UpgradeDealsPageContainer = ((0,DependencyHelper.connect)(UpgradeDealsPageContainer_mapStateToProps, {
  generateOTP: upgradeAction/* generateOTP */.P,
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex
})(UpgradeDealsPageContainer));
// EXTERNAL MODULE: ./services/breadcrumbService.js
var breadcrumbService = __webpack_require__(74425);
// EXTERNAL MODULE: ./services/filterDealService.js
var filterDealService = __webpack_require__(4945);
// EXTERNAL MODULE: ./components/molecules/errorPage/errorPage.jsx
var errorPage = __webpack_require__(46005);
;// CONCATENATED MODULE: ./pages/shopping/upgrade.js



function upgrade_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function upgrade_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? upgrade_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : upgrade_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var UpgradePage = function UpgradePage(props) {
  var _productList$products, _productList$products2, _props$creditFilters5;

  // const [resultData, setResultData] = useState({});
  var _useState = (0,react.useState)([]),
      brands = _useState[0],
      setBrands = _useState[1];

  var _useState2 = (0,react.useState)([]),
      models = _useState2[0],
      setModels = _useState2[1];

  var windowSize = (0,helperServices/* componentCheckSize */.Qj)();
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < 577;
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() < 992;

  var _useState3 = (0,react.useState)(null),
      staticText = _useState3[0],
      setStaticText = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      carouselData = _useState4[0],
      setCarouselData = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      simpleCardData = _useState5[0],
      setSimpleCardData = _useState5[1];

  var _useState6 = (0,react.useState)(true),
      displayLanding = _useState6[0],
      setDisplayLanding = _useState6[1];

  var _useState7 = (0,react.useState)(labels/* default.upgrade.planData.lbl_contract_with_device */.Z.upgrade.planData.lbl_contract_with_device),
      selectedContractType = _useState7[0],
      setSelectedContractType = _useState7[1];

  var _useState8 = (0,react.useState)(),
      selectedBrand = _useState8[0],
      setSelectedBrand = _useState8[1];

  var _useState9 = (0,react.useState)(),
      selectedModel = _useState9[0],
      setSelectedModel = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      showModal = _useState10[0],
      setShowModal = _useState10[1];

  var _useState11 = (0,react.useState)([]),
      dealSkus = _useState11[0],
      setDealSkus = _useState11[1];

  var _useState12 = (0,react.useState)(props.unMaskedMsisdn),
      selectedNumber = _useState12[0],
      setSelectedNumber = _useState12[1];

  var _useState13 = (0,react.useState)([]),
      selectedDealFilter = _useState13[0],
      setSelectedDealFilter = _useState13[1];

  var _useState14 = (0,react.useState)(true),
      loadingProducts = _useState14[0],
      setLoadingProducts = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      isAlternate = _useState15[0],
      setisAlternate = _useState15[1];

  var _useState16 = (0,react.useState)(),
      productList = _useState16[0],
      setProductList = _useState16[1];

  var _useState17 = (0,react.useState)((productList === null || productList === void 0 ? void 0 : (_productList$products = productList.products) === null || _productList$products === void 0 ? void 0 : (_productList$products2 = _productList$products.page_info) === null || _productList$products2 === void 0 ? void 0 : _productList$products2.current_page) || 1),
      currentPage = _useState17[0],
      setCurrentPage = _useState17[1];

  var _useState18 = (0,react.useState)(labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended),
      sortBy = _useState18[0],
      setSortBy = _useState18[1];

  var _useState19 = (0,react.useState)(),
      pastUsageParagraph = _useState19[0],
      setPastUsageParagraph = _useState19[1];

  var _useState20 = (0,react.useState)(!!props.msisdn),
      isPrevious = _useState20[0],
      setIsPrevious = _useState20[1];

  var _useState21 = (0,react.useState)(0),
      positionX = _useState21[0],
      setPositionX = _useState21[1];

  var _useState22 = (0,react.useState)(false),
      isContractTypeFilterApplied = _useState22[0],
      setContractTypeFilterApplied = _useState22[1];

  var _useState23 = (0,react.useState)(false),
      isBrandFilterApplied = _useState23[0],
      setBrandFilterApplied = _useState23[1];

  var _useState24 = (0,react.useState)(false),
      isModelFilterApplied = _useState24[0],
      setModelFilterApplied = _useState24[1];

  var planData = [labels/* default.upgrade.planData.lbl_contract_with_device */.Z.upgrade.planData.lbl_contract_with_device, labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only];
  var mainContainerRef = /*#__PURE__*/(0,react.createRef)();
  (0,react.useEffect)(function () {
    var current = mainContainerRef.current;

    if (current) {
      var elemRect = current.getBoundingClientRect();
      setPositionX(elemRect.x);
    }
  }, [mainContainerRef]);
  (0,react.useEffect)(function () {
    window.scrollTo(0, 0);

    function fetchContent() {
      return _fetchContent.apply(this, arguments);
    }

    function _fetchContent() {
      _fetchContent = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var resultData, i;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "upgradeEligibleCheck");

              case 3:
                resultData = _context.sent;

                if (!resultData) {
                  _context.next = 19;
                  break;
                }

                i = 0;

              case 6:
                if (!(i < resultData.sections.length)) {
                  _context.next = 19;
                  break;
                }

                _context.t0 = resultData.sections[i].type;
                _context.next = _context.t0 === "paragraph_list" ? 10 : _context.t0 === "small_card_image_carousel" ? 12 : _context.t0 === "paragraph" ? 14 : 16;
                break;

              case 10:
                setStaticText(resultData.sections[i]);
                return _context.abrupt("break", 16);

              case 12:
                if (resultData.sections[i].cardType == "Carousel") {
                  setCarouselData(resultData.sections[i]);
                } else {
                  setSimpleCardData(resultData.sections[i]);
                }

                return _context.abrupt("break", 16);

              case 14:
                if (resultData.sections[i].analyticTitle == "Upgrade usage - Past Usage and Spend") {
                  setPastUsageParagraph(resultData.sections[i]);
                }

                return _context.abrupt("break", 16);

              case 16:
                i++;
                _context.next = 6;
                break;

              case 19:
                return _context.abrupt("return", resultData);

              case 22:
                _context.prev = 22;
                _context.t1 = _context["catch"](0);
                console.log("Error", _context.t1);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 22]]);
      }));
      return _fetchContent.apply(this, arguments);
    }

    fetchContent();
  }, []);
  (0,react.useEffect)(function () {
    var _props$creditFilters;

    if (!displayLanding && props !== null && props !== void 0 && (_props$creditFilters = props.creditFilters) !== null && _props$creditFilters !== void 0 && _props$creditFilters.total_monthly_payment) {
      var _props$upgradeRespons, _props$creditFilters2, _props$creditFilters3, _props$creditFilters4, _props$upgradeRespons2;

      setProductList();
      props.getLookupData();
      props.getRecommendedDeals((_props$upgradeRespons = props.upgradeResponse) === null || _props$upgradeRespons === void 0 ? void 0 : _props$upgradeRespons.msisdn, "", "", "", (_props$creditFilters2 = props.creditFilters) === null || _props$creditFilters2 === void 0 ? void 0 : _props$creditFilters2.total_monthly_payment, (_props$creditFilters3 = props.creditFilters) === null || _props$creditFilters3 === void 0 ? void 0 : _props$creditFilters3.deviceInstallment, (_props$creditFilters4 = props.creditFilters) === null || _props$creditFilters4 === void 0 ? void 0 : _props$creditFilters4.financeIndicator, "", (_props$upgradeRespons2 = props.upgradeResponse) === null || _props$upgradeRespons2 === void 0 ? void 0 : _props$upgradeRespons2.simOnlyUpgradeFlg);
    }
  }, [props.upgradeResponse.msisdn, displayLanding, (_props$creditFilters5 = props.creditFilters) === null || _props$creditFilters5 === void 0 ? void 0 : _props$creditFilters5.total_monthly_payment]);
  (0,react.useEffect)(function () {
    var _props$manufacturers;

    setBrands((_props$manufacturers = props.manufacturers) === null || _props$manufacturers === void 0 ? void 0 : _props$manufacturers.sort());
  }, [props.manufacturers]);
  (0,react.useEffect)(function () {
    if (selectedBrand) {
      props.getDeviceModels(selectedBrand);
    }
  }, [selectedBrand]);
  (0,react.useEffect)(function () {
    var modelsArr = [];

    for (var i = 0; i < ((_props$deviceModels = props.deviceModels) === null || _props$deviceModels === void 0 ? void 0 : _props$deviceModels.length); i++) {
      var _props$deviceModels;

      modelsArr.push(props.deviceModels[i].model);
    }

    setModels(modelsArr);
  }, [props.deviceModels]);
  (0,react.useEffect)(function () {
    if (props.resultCode && (props.journeyStatus === upgradeService/* upgradeStages.UPGRADE_RESULT */.wv.UPGRADE_RESULT || props.journeyStatus === upgradeService/* upgradeStages.TECHNICAL_ERROR */.wv.TECHNICAL_ERROR)) {
      props.fetchDisplayDetails(props.resultCode);
    }
  }, [props.journeyStatus, props.resultCode]);
  (0,react.useEffect)(function () {
    var _props$recommendedSku;

    var dealArr = [];

    if (((_props$recommendedSku = props.recommendedSkus) === null || _props$recommendedSku === void 0 ? void 0 : _props$recommendedSku.length) > 0) {
      for (var i = 0; i < props.recommendedSkus.length; i++) {
        dealArr.push(props.recommendedSkus[i].dealsheetNumber);
      }

      setDealSkus(dealArr);
    } else {
      setDealSkus([]);
    }
  }, [props.recommendedSkus]);

  var searchDeals = function searchDeals() {
    var _props$creditFilters6, _props$creditFilters7, _props$creditFilters8, _props$upgradeRespons3;

    setProductList();
    props.getRecommendedDeals(selectedNumber, selectedContractType === labels/* default.upgrade.planData.lbl_contract_sim_only */.Z.upgrade.planData.lbl_contract_sim_only ? "Y" : "", selectedBrand, selectedModel, (_props$creditFilters6 = props.creditFilters) === null || _props$creditFilters6 === void 0 ? void 0 : _props$creditFilters6.total_monthly_payment, (_props$creditFilters7 = props.creditFilters) === null || _props$creditFilters7 === void 0 ? void 0 : _props$creditFilters7.deviceInstallment, (_props$creditFilters8 = props.creditFilters) === null || _props$creditFilters8 === void 0 ? void 0 : _props$creditFilters8.financeIndicator, "", (_props$upgradeRespons3 = props.upgradeResponse) === null || _props$upgradeRespons3 === void 0 ? void 0 : _props$upgradeRespons3.simOnlyUpgradeFlg);
  };

  var updateCurrentPage = function updateCurrentPage(page) {
    setCurrentPage(page);
  }; // let dealArr=["DV20K28630","DV20K28622","DV0JD08419","DV20K28629","DV20K28625","DV0JD08417","DV0JD05135","DV20K28627","DV20K28623","DV0JD08419"];


  (0,react.useEffect)(function () {
    if (dealSkus.length > 0) {
      fetchData();
    }
  }, [dealSkus, currentPage]);
  (0,react.useEffect)(function () {
    fetchData();
  }, [sortBy]);

  var resetFilter = function resetFilter() {
    setSelectedDealFilter([]);
  };

  var pageSize = function pageSize() {
    var size = "12";

    if (windowSize < 576) {
      size = "8";
    } else if (windowSize > 576 && windowSize < 992) {
      size = "10";
    } else {
      size = "12";
    }

    return size;
  };

  var fetchData = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var sortParam, result;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sortParam = (0,filterDealService/* getSortQueryForDeals */.Uv)(sortBy);

              if (!((dealSkus === null || dealSkus === void 0 ? void 0 : dealSkus.length) > 0)) {
                _context2.next = 8;
                break;
              }

              (0,helperServices/* showSpinner */.yh)();
              setLoadingProducts(true);
              _context2.next = 6;
              return (0,filterDealService/* createFilterRequestForDealSelection */.Yu)(dealSkus, pageSize(), sortParam, currentPage, selectedDealFilter, "", "upgrade")["finally"](function () {
                (0,helperServices/* hideSpinner */.v3)();
              });

            case 6:
              result = _context2.sent;

              if (result) {
                setLoadingProducts(false);
                setProductList(result);
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchData() {
      return _ref.apply(this, arguments);
    };
  }();

  var analyticsHandleSortFilter = function analyticsHandleSortFilter(value) {
    analyticsUtag/* link */.p4(upgrade_objectSpread(upgrade_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "sales_product_id", "sales_product_price", "sales_product_quantity", "page_site_section_lvl_1", "page_site_section_lvl_2", "page_site_section_lvl_3", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: deal selection: sort by filter",
      filter_query: value
    }));
  };

  (0,react.useEffect)(function () {
    var isIE =
    /*@cc_on!@*/
     false || !!document.documentMode;

    if (isIE) {
      var el = document.querySelector("div[class*='NavItems_menu-sub']");

      if (el) {
        el.classList.add('d-none');
      }

      window.scroll(0, 0);
    }

    if (isMobile) {
      window.scroll(0, 0);
    }
  }, []);

  var LandingPage = function LandingPage() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        children: staticText && /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeTopContainer_UpgradeTopContainer, {
          selectedNumber: selectedNumber,
          staticText: staticText,
          setSelectedNumber: setSelectedNumber,
          isPrevious: isPrevious,
          setIsPrevious: setIsPrevious,
          isAlternate: isAlternate,
          setisAlternate: setisAlternate
        })
      })
    });
  };

  (0,react.useEffect)(function () {
    function setDisplayData() {
      return _setDisplayData.apply(this, arguments);
    }

    function _setDisplayData() {
      _setDisplayData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var _props$upgradeRespons4;

        var result;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(props !== null && props !== void 0 && (_props$upgradeRespons4 = props.upgradeResponse) !== null && _props$upgradeRespons4 !== void 0 && _props$upgradeRespons4.resultCode)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "upgradeResult", [props.upgradeResponse.resultCode.toLowerCase()]);

              case 3:
                result = _context3.sent;

                if (result && result.length) {
                  props.setSelectedDisplayData(result[0]);
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _setDisplayData.apply(this, arguments);
    }

    setDisplayData();
  }, [props.upgradeResponse]);

  var SecondPage = function SecondPage() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(upgradeDealsPageContainer_UpgradeDealsPageContainer, {
        setSelectedContractType: setSelectedContractType,
        setSelectedBrand: setSelectedBrand,
        setSelectedModel: setSelectedModel,
        brands: brands,
        models: models,
        planData: planData,
        selectedContractType: selectedContractType,
        selectedNumber: selectedNumber,
        setSelectedNumber: setSelectedNumber,
        selectedBrand: selectedBrand,
        productList: productList,
        setSortBy: setSortBy,
        sortBy: sortBy,
        updateCurrentPage: updateCurrentPage,
        resetFilter: resetFilter,
        upgradeDisplayData: props.upgradeDisplayData,
        analyticsHandleSortFilter: analyticsHandleSortFilter,
        searchDeals: searchDeals,
        pastUsageParagraph: pastUsageParagraph,
        loadingProducts: loadingProducts,
        selectedModel: selectedModel,
        setShowModal: setShowModal,
        simpleCardData: simpleCardData,
        dealApiError: props.dealApiError,
        isContractTypeFilterApplied: isContractTypeFilterApplied,
        isBrandFilterApplied: isBrandFilterApplied,
        isModelFilterApplied: isModelFilterApplied,
        dealSkus: dealSkus
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeFiltersModal_UpgradeFiltersModal, {
        showModal: showModal,
        setShowModal: setShowModal,
        setSortBy: setSortBy,
        setSelectedContractType: setSelectedContractType,
        setSelectedBrand: setSelectedBrand,
        setSelectedModel: setSelectedModel,
        selectedContractType: selectedContractType,
        selectedBrand: selectedBrand,
        selectedModel: selectedModel,
        brands: brands,
        models: models,
        products: productList,
        planData: planData,
        applyFilters: searchDeals,
        setContractTypeFilterApplied: setContractTypeFilterApplied,
        setBrandFilterApplied: setBrandFilterApplied,
        setModelFilterApplied: setModelFilterApplied
      })]
    });
  };

  var debouncedAnalytics = (0,react.useCallback)((0,helperServices/* debounce */.Ds)(function (upgradeCheckDone, userMetaData) {
    return viewAnalytics(upgradeCheckDone, userMetaData);
  }, 800), [] // will be created only once initially
  );

  var viewAnalytics = function viewAnalytics(upgradeCheckDone, userMetaData) {
    if (!upgradeCheckDone) {
      analyticsUtag/* view */.ei(upgrade_objectSpread(upgrade_objectSpread({
        page_event: "view",
        page_name: props.msisdn || isPrevious ? "shopping: upgrade: eligibility: another number" : "shopping: upgrade: eligibility",
        page_channel: "shopping",
        page_master_tab: "personal"
      }, userMetaData), {}, {
        page_site_section_lvl_1: "upgrade",
        page_site_section_lvl_2: "home"
      }));
    } else {
      var _props$upgradeRespons5, _props$upgradeRespons6, _props$upgradeRespons7, _props$upgradeRespons8;

      analyticsUtag/* view */.ei(upgrade_objectSpread(upgrade_objectSpread({
        page_event: "view",
        page_name: "shopping: upgrade: recommended deals",
        page_channel: "shopping",
        page_master_tab: "personal"
      }, userMetaData), {}, {
        upgrade_eligibility_status: "".concat((_props$upgradeRespons5 = props.upgradeResponse) !== null && _props$upgradeRespons5 !== void 0 && _props$upgradeRespons5.upgradeEligible ? props.upgradeResponse.upgradeEligible : false),
        upgrade_eligible_date: ((_props$upgradeRespons6 = props.upgradeResponse) === null || _props$upgradeRespons6 === void 0 ? void 0 : _props$upgradeRespons6.upgradeDate) || null,
        upgrade_customer_type: !props.upgradeResponse ? null : (_props$upgradeRespons7 = props.upgradeResponse) !== null && _props$upgradeRespons7 !== void 0 && _props$upgradeRespons7.c3dCustomer ? "C3D" : (_props$upgradeRespons8 = props.upgradeResponse) !== null && _props$upgradeRespons8 !== void 0 && _props$upgradeRespons8.business ? "EBU" : "Legacy"
      }));
    }
  };

  (0,react.useEffect)(function () {
    var _props$upgradeRespons9;

    if (props.upgradeCheckDone && (_props$upgradeRespons9 = props.upgradeResponse) !== null && _props$upgradeRespons9 !== void 0 && _props$upgradeRespons9.upgradeEligible) {
      setDisplayLanding(false);
      setisAlternate(false);
    } else {
      setSelectedNumber(props.unMaskedMsisdn);
      setIsPrevious(!!props.msisdn);
      setDisplayLanding(true);
    }

    window.scroll(0, 0);
    var userMetaData = analyticsUtag/* getProfileData */.$y(props.userLoggedIn, props.profileData, props.authDetails);

    if (props.upgradeChecksEnabled && !isAlternate) {
      debouncedAnalytics(props === null || props === void 0 ? void 0 : props.upgradeCheckDone, userMetaData);
    }
  }, [props.upgradeCheckDone, isAlternate]);
  (0,react.useEffect)(function () {
    setIsPrevious(!!props.msisdn);
  }, [props === null || props === void 0 ? void 0 : props.msisdn]);
  (0,react.useEffect)(function () {
    var _props$linkedNumbers;

    var userMetaData = analyticsUtag/* getProfileData */.$y(props.userLoggedIn, props.profileData, props.authDetails);

    if (isAlternate && (_props$linkedNumbers = props.linkedNumbers) !== null && _props$linkedNumbers !== void 0 && _props$linkedNumbers.length) {
      analyticsUtag/* view */.ei(upgrade_objectSpread(upgrade_objectSpread({
        page_event: "view",
        page_name: "shopping: upgrade: eligibility: send otp",
        page_channel: "shopping",
        page_master_tab: "personal"
      }, userMetaData), {}, {
        page_site_section_lvl_1: "upgrade",
        page_site_section_lvl_2: "home"
      }));
    }
  }, [isAlternate, props.linkedNumbers]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: props.upgradeChecksEnabled ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: isMobile || isTablet ? "upgrade container-fluid" : "upgrade container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          ref: mainContainerRef,
          className: "upgrade__breadcrumb",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb["default"], {
            list: (0,helperServices/* formatBreadCrumb */.x9)((0,breadcrumbService/* breadcrumbGenerator */.G)().upgradePage)
          })
        }), displayLanding ? LandingPage() : SecondPage()]
      }), displayLanding && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
        fluid: true,
        children: carouselData && /*#__PURE__*/(0,jsx_runtime.jsx)(UpgradeCarousel_UpgradeCarousel, {
          positionX: positionX,
          carouselData: carouselData
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(errorPage/* default */.Z, {
      statusCode: 404
    })
  });
};

var upgrade_mapStateToProps = function mapStateToProps(state) {
  return {
    manufacturers: state.upgrade.manufacturers,
    deviceModels: state.upgrade.deviceModels,
    recommendedSkus: state.upgrade.recommendedSkus,
    upgradeDisplayData: state.upgrade.selectedUpgradeDisplayData,
    resultCode: state.upgrade.resultCode,
    journeyStatus: state.upgrade.upgradeStatus,
    upgradeCheckDone: state.upgrade.upgradeCheckDone,
    upgradeResponse: state.upgrade.selectedUpgradeResponse,
    msisdn: state.upgrade.msisdn,
    unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
    profileData: state.navDetails.profileData,
    authDetails: state.checkoutDetails.authDetails,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    allUpgradesData: state.upgrade.allUpgradesData,
    creditFilters: state.upgrade.creditFilters,
    linkedNumbers: state.upgrade.linkedNumbers,
    dealApiError: state.upgrade.dealApiError
  };
};

var __N_SSP = true;
/* harmony default export */ var upgrade = ((0,DependencyHelper.connect)(upgrade_mapStateToProps, {
  getLookupData: upgradeAction/* getLookupData */.YA,
  getDeviceModels: upgradeAction/* getDeviceModels */.Mn,
  getRecommendedDeals: upgradeAction/* getRecommendedDeals */.VZ,
  fetchDisplayDetails: upgradeAction/* fetchDisplayDetails */.NO,
  setSelectedDisplayData: upgradeAction/* setSelectedDisplayData */.HZ
})(UpgradePage));

/***/ }),

/***/ 74425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ breadcrumbGenerator; }
/* harmony export */ });
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);



var breadcrumbGenerator = function breadcrumbGenerator(customBreadcrumb) {
  var _labels$Session_Keys, _getSessionStorage$, _labels$Session_Keys2;

  var productlistfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys === void 0 ? void 0 : _labels$Session_Keys.lbl_list_page_router_with_filters) ? (_getSessionStorage$ = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys2 = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys2 === void 0 ? void 0 : _labels$Session_Keys2.lbl_list_page_router_with_filters)[0]) === null || _getSessionStorage$ === void 0 ? void 0 : _getSessionStorage$.products : "/shopping/products";
  var dealfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") : "/shopping/deals";
  var router = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var breadcrumbconfig = {
    productlist: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/products",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }],
    cmsPage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.link,
      label: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.label
    }],
    productdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }],
    productcompare: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-compare",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_compare_products */ .Z.BreadCrumbLabels.lbl_compare_products
    }],
    deals: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }],
    dealdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }, {
      link: "/shopping/deal-details-page/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_deal_details */ .Z.BreadCrumbLabels.lbl_deal_details
    }],
    dealselection: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/".concat(router.query.id),
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }, {
      link: "/shopping/deal-selection",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_select_deal */ .Z.lbl_select_deal
    }],
    orderhistory: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }],
    orderdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/view-order-details",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_details */ .Z.BreadCrumbLabels.lbl_order_details
    }],
    trackorder: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/track-my-order",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_track_order */ .Z.BreadCrumbLabels.lbl_track_order
    }],
    upgradePage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/upgrade",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_upgrade_page */ .Z.BreadCrumbLabels.lbl_upgrade_page
    }]
  };
  return breadcrumbconfig;
};

/***/ }),

/***/ 83059:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/upgrade",
      function () {
        return __webpack_require__(74010);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"BreadCrumb_p-xxs__heuAZ","pl-xxs":"BreadCrumb_pl-xxs__Pq2yx","pr-xxs":"BreadCrumb_pr-xxs__LOdz9","pb-xxs":"BreadCrumb_pb-xxs__dYHA5","pt-xxs":"BreadCrumb_pt-xxs__I5eh2","m-xxs":"BreadCrumb_m-xxs__BV_wk","ml-xxs":"BreadCrumb_ml-xxs__AFLMm","mr-xxs":"BreadCrumb_mr-xxs__PCCSC","mb-xxs":"BreadCrumb_mb-xxs__afj_v","mt-xxs":"BreadCrumb_mt-xxs__hsFq1","px-xxs":"BreadCrumb_px-xxs__JeufQ","mx-xxs":"BreadCrumb_mx-xxs__6nDs8","my-xxs":"BreadCrumb_my-xxs__ExH3B","py-xxs":"BreadCrumb_py-xxs___yoiL","font-size-xxs":"BreadCrumb_font-size-xxs__G3b3k","p-xs":"BreadCrumb_p-xs__Ydf2v","pl-xs":"BreadCrumb_pl-xs__4KFtt","pr-xs":"BreadCrumb_pr-xs__j5LDB","pb-xs":"BreadCrumb_pb-xs__r7wlS","pt-xs":"BreadCrumb_pt-xs__lYyC_","m-xs":"BreadCrumb_m-xs__kqGup","ml-xs":"BreadCrumb_ml-xs__9fxNn","mr-xs":"BreadCrumb_mr-xs__MnHIX","mb-xs":"BreadCrumb_mb-xs__2kV_4","mt-xs":"BreadCrumb_mt-xs__TWQWC","px-xs":"BreadCrumb_px-xs__POnB8","mx-xs":"BreadCrumb_mx-xs__NWC0P","my-xs":"BreadCrumb_my-xs__Ov9pH","py-xs":"BreadCrumb_py-xs__6k99w","font-size-xs":"BreadCrumb_font-size-xs__TDTVR","p-ss":"BreadCrumb_p-ss__8nenT","pl-ss":"BreadCrumb_pl-ss__E6s6_","pr-ss":"BreadCrumb_pr-ss__bDcG5","pb-ss":"BreadCrumb_pb-ss__J6_Jj","pt-ss":"BreadCrumb_pt-ss__V9sXm","m-ss":"BreadCrumb_m-ss__MksLc","ml-ss":"BreadCrumb_ml-ss__IgrfK","mr-ss":"BreadCrumb_mr-ss__NBuN5","mb-ss":"BreadCrumb_mb-ss__eXzqE","mt-ss":"BreadCrumb_mt-ss__RtZGW","px-ss":"BreadCrumb_px-ss__iSdiI","mx-ss":"BreadCrumb_mx-ss__gmV4s","my-ss":"BreadCrumb_my-ss__vBgaK","py-ss":"BreadCrumb_py-ss__6S3aJ","font-size-ss":"BreadCrumb_font-size-ss__8a9R5","p-ms":"BreadCrumb_p-ms__ekoV9","pl-ms":"BreadCrumb_pl-ms__D7tmj","pr-ms":"BreadCrumb_pr-ms__e2sRD","pb-ms":"BreadCrumb_pb-ms__rnAj_","pt-ms":"BreadCrumb_pt-ms__ag7m4","m-ms":"BreadCrumb_m-ms__T9KF0","ml-ms":"BreadCrumb_ml-ms__5RRFE","mr-ms":"BreadCrumb_mr-ms__wfkjE","mb-ms":"BreadCrumb_mb-ms__NUSVf","mt-ms":"BreadCrumb_mt-ms__O7sWI","px-ms":"BreadCrumb_px-ms__4XByK","mx-ms":"BreadCrumb_mx-ms__Tnh9Z","my-ms":"BreadCrumb_my-ms__2jObH","py-ms":"BreadCrumb_py-ms__QLzHK","font-size-ms":"BreadCrumb_font-size-ms__Ii_oH","p-s":"BreadCrumb_p-s__Ao5TN","pl-s":"BreadCrumb_pl-s__kmzwv","pr-s":"BreadCrumb_pr-s__0GvID","pb-s":"BreadCrumb_pb-s__LMNvJ","pt-s":"BreadCrumb_pt-s__DN70M","m-s":"BreadCrumb_m-s__Gfub1","ml-s":"BreadCrumb_ml-s__T1n7a","mr-s":"BreadCrumb_mr-s__JM_qb","mb-s":"BreadCrumb_mb-s__Y9fra","mt-s":"BreadCrumb_mt-s__TgqdQ","px-s":"BreadCrumb_px-s__B4BJD","mx-s":"BreadCrumb_mx-s__ggx55","my-s":"BreadCrumb_my-s__VOnn0","py-s":"BreadCrumb_py-s__RJTVn","font-size-s":"BreadCrumb_font-size-s__OJxvW","p-m":"BreadCrumb_p-m__4jcNq","pl-m":"BreadCrumb_pl-m__qoFdT","pr-m":"BreadCrumb_pr-m__fCW0F","pb-m":"BreadCrumb_pb-m__4_21j","pt-m":"BreadCrumb_pt-m__1bU9M","m-m":"BreadCrumb_m-m__piMyJ","ml-m":"BreadCrumb_ml-m__oBCf_","mr-m":"BreadCrumb_mr-m__p9RbI","mb-m":"BreadCrumb_mb-m__W6HyL","mt-m":"BreadCrumb_mt-m__gibKu","px-m":"BreadCrumb_px-m__NFUVV","mx-m":"BreadCrumb_mx-m__ACbJ1","my-m":"BreadCrumb_my-m__IDE7l","py-m":"BreadCrumb_py-m__I1kXn","font-size-m":"BreadCrumb_font-size-m__5EbDy","p-l":"BreadCrumb_p-l___LdZT","pl-l":"BreadCrumb_pl-l__1c4Iu","pr-l":"BreadCrumb_pr-l__euf69","pb-l":"BreadCrumb_pb-l__naQqI","pt-l":"BreadCrumb_pt-l__2H63b","m-l":"BreadCrumb_m-l__LFNUk","ml-l":"BreadCrumb_ml-l__AUqRa","mr-l":"BreadCrumb_mr-l__d60lJ","mb-l":"BreadCrumb_mb-l__xoQ9d","mt-l":"BreadCrumb_mt-l__FpoKd","px-l":"BreadCrumb_px-l__R8GEA","mx-l":"BreadCrumb_mx-l__0zBpp","my-l":"BreadCrumb_my-l__tYR_K","py-l":"BreadCrumb_py-l__fWTn6","font-size-l":"BreadCrumb_font-size-l__kHO4q","p-xl":"BreadCrumb_p-xl__sVryE","pl-xl":"BreadCrumb_pl-xl__OKP64","pr-xl":"BreadCrumb_pr-xl__6IFNa","pb-xl":"BreadCrumb_pb-xl__WaJwF","pt-xl":"BreadCrumb_pt-xl__apbAF","m-xl":"BreadCrumb_m-xl__gKVFJ","ml-xl":"BreadCrumb_ml-xl__RboKO","mr-xl":"BreadCrumb_mr-xl__dpz2h","mb-xl":"BreadCrumb_mb-xl__uOh3J","mt-xl":"BreadCrumb_mt-xl__FFF7p","px-xl":"BreadCrumb_px-xl__ITzPQ","mx-xl":"BreadCrumb_mx-xl__x7GK3","my-xl":"BreadCrumb_my-xl__2QEJ2","py-xl":"BreadCrumb_py-xl__bNH7S","font-size-xl":"BreadCrumb_font-size-xl__QyImp","p-xxl":"BreadCrumb_p-xxl__5ZYd6","pl-xxl":"BreadCrumb_pl-xxl__TlpF5","pr-xxl":"BreadCrumb_pr-xxl__Jw5VV","pb-xxl":"BreadCrumb_pb-xxl__6i7kj","pt-xxl":"BreadCrumb_pt-xxl__s5KBw","m-xxl":"BreadCrumb_m-xxl__whIb2","ml-xxl":"BreadCrumb_ml-xxl__kkiO1","mr-xxl":"BreadCrumb_mr-xxl__Rqk9w","mb-xxl":"BreadCrumb_mb-xxl__UvCHx","mt-xxl":"BreadCrumb_mt-xxl__3CXiR","px-xxl":"BreadCrumb_px-xxl__t2uey","mx-xxl":"BreadCrumb_mx-xxl__72iew","my-xxl":"BreadCrumb_my-xxl__xu_qX","py-xxl":"BreadCrumb_py-xxl__KknxS","font-size-xxl":"BreadCrumb_font-size-xxl__l_W0q","overflow-hidden":"BreadCrumb_overflow-hidden__6Pek3","topMargin":"BreadCrumb_topMargin__h_vBW","breadcrumb-wrapper":"BreadCrumb_breadcrumb-wrapper__PXx8y","breadcrumb-list":"BreadCrumb_breadcrumb-list__bwQ2f","breadcrumb-item":"BreadCrumb_breadcrumb-item__8lNEe"};

/***/ }),

/***/ 98033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"owl--oval":"carouselButton_owl--oval__2x4zk","btn":"carouselButton_btn__K9EnQ","btn__bg":"carouselButton_btn__bg__zoNpp","btn--prev":"carouselButton_btn--prev__Z2Xov","btn__sm":"carouselButton_btn__sm__XBSMi","btn__arrow":"carouselButton_btn__arrow__OgC6m","btn--next":"carouselButton_btn--next__HmNG8","btn--sm":"carouselButton_btn--sm__WNEx5","btn--bg":"carouselButton_btn--bg__Y9yXv","owl--po__left":"carouselButton_owl--po__left__m9gqy","owl--po__right":"carouselButton_owl--po__right__HtFGZ","owl--clear":"carouselButton_owl--clear__LELqL","white":"carouselButton_white__4FH5k","black":"carouselButton_black__sMHCV","icon__sm":"carouselButton_icon__sm__P1FDk","icon__bg":"carouselButton_icon__bg__WCM5J","dark":"carouselButton_dark__e1pUx","light":"carouselButton_light__Ezw73"};

/***/ }),

/***/ 58043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"category":"UpgradeFiltersModal_category__lJSew","arrow":"UpgradeFiltersModal_arrow__5eBv2","buttons-section":"UpgradeFiltersModal_buttons-section__qiNqk","button":"UpgradeFiltersModal_button__7eCRf","reset":"UpgradeFiltersModal_reset__sR3qK","category-title":"UpgradeFiltersModal_category-title__ft4bi","sub-category":"UpgradeFiltersModal_sub-category__BpLi_","active-option":"UpgradeFiltersModal_active-option__DE1Zs","category-container":"UpgradeFiltersModal_category-container__7rzMf","apply":"UpgradeFiltersModal_apply__uEIKR","show-results":"UpgradeFiltersModal_show-results__5TOXi","show-results__button":"UpgradeFiltersModal_show-results__button__5Q0B8","show-results__save-selection":"UpgradeFiltersModal_show-results__save-selection__odhXl","disabled":"UpgradeFiltersModal_disabled__PaSsQ","selection_for":"UpgradeFiltersModal_selection_for__02otd"};

/***/ }),

/***/ 62056:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-banner-wrapper":"UpgradeInfoBanner_upgrade-banner-wrapper__x6tY2","upgrade-banner-mark":"UpgradeInfoBanner_upgrade-banner-mark__OOnzy","upgrade-banner-main-text":"UpgradeInfoBanner_upgrade-banner-main-text__FiAfa","upgrade-banner-sub-text":"UpgradeInfoBanner_upgrade-banner-sub-text__JPuk6","upgrade-banner-info":"UpgradeInfoBanner_upgrade-banner-info__2RGFw","upgrade-banner-info-bold":"UpgradeInfoBanner_upgrade-banner-info-bold__lo_lM","info-label":"UpgradeInfoBanner_info-label__IMOee","button-container":"UpgradeInfoBanner_button-container__oKL4H","button":"UpgradeInfoBanner_button___B9QP","button-text":"UpgradeInfoBanner_button-text__xo7uL","button-selected":"UpgradeInfoBanner_button-selected__XsRn0","button-selected-text":"UpgradeInfoBanner_button-selected-text__5gTZ_","upgrade-select":"UpgradeInfoBanner_upgrade-select__Y7UGN","select-item":"UpgradeInfoBanner_select-item__kkt71","modal-body":"UpgradeInfoBanner_modal-body__0XfMt","modal-content":"UpgradeInfoBanner_modal-content__GW_Xc","upgrade-banner-mark-modal":"UpgradeInfoBanner_upgrade-banner-mark-modal__Fu1J0","button-disabled":"UpgradeInfoBanner_button-disabled__M8nHx","info-text":"UpgradeInfoBanner_info-text__vDoHb","upgrade-banner-wrapper-modal":"UpgradeInfoBanner_upgrade-banner-wrapper-modal__JE3yt","upgrade-select__option":"UpgradeInfoBanner_upgrade-select__option__T3YIz","cta-button":"UpgradeInfoBanner_cta-button__4UrsY","cta-button-text":"UpgradeInfoBanner_cta-button-text___BJRc","cta-button-text-disabled":"UpgradeInfoBanner_cta-button-text-disabled__Vgu64","cta-button-disabled":"UpgradeInfoBanner_cta-button-disabled__fQTaO"};

/***/ }),

/***/ 34289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"errorPage_error__IZm6B","code":"errorPage_code__8Cazo","wrapper":"errorPage_wrapper__27LZ3","message":"errorPage_message__eTWen"};

/***/ }),

/***/ 40001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"underline":"homeTabs_underline__0C7Fi","tabs-design__nav":"homeTabs_tabs-design__nav__NMald","home-tabs-container":"homeTabs_home-tabs-container__Nn9xX","tabs-design__nav--left":"homeTabs_tabs-design__nav--left__lXyVY","tabs-design__nav--right":"homeTabs_tabs-design__nav--right__Px4AE","tab-link--active":"homeTabs_tab-link--active__7YqZn","tab-link":"homeTabs_tab-link__h6Vnm","active":"homeTabs_active__wQ8Uh","tabs-design__nav--black-with-line":"homeTabs_tabs-design__nav--black-with-line__KVOxD","tabs-design__nav--black-without-line":"homeTabs_tabs-design__nav--black-without-line__LB7tU","tabs-design__nav--red-with-line":"homeTabs_tabs-design__nav--red-with-line__88vl5","tabs-design__nav--red-without-line":"homeTabs_tabs-design__nav--red-without-line__D1Gxw","tabs-design__nav--large-black":"homeTabs_tabs-design__nav--large-black__6jIX_","tabs-design__content":"homeTabs_tabs-design__content__Xp2B9","tabs-design__nav--line-secondary":"homeTabs_tabs-design__nav--line-secondary__xxBFb","tabs-design__nav--line-primary":"homeTabs_tabs-design__nav--line-primary__z6bwb","tabs-design__nav--button":"homeTabs_tabs-design__nav--button__5tKXq","tabs-design__nav--pill":"homeTabs_tabs-design__nav--pill__JMQtG","past-usage-tab":"homeTabs_past-usage-tab__Xnn4E","nav-alignment":"homeTabs_nav-alignment__fchxp","upgrade-custom":"homeTabs_upgrade-custom__7Y_qq"};

/***/ }),

/***/ 1234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-top-container":"UpgradeTopContainer_upgrade-top-container__h9fbn","upgrade-top-container__otp":"UpgradeTopContainer_upgrade-top-container__otp___TSY_","upgrade-top-container__paragraph":"UpgradeTopContainer_upgrade-top-container__paragraph__F5BcF","upgrade-top-container__paragraph__heading":"UpgradeTopContainer_upgrade-top-container__paragraph__heading__wvSgP","upgrade-top-container__paragraph__description":"UpgradeTopContainer_upgrade-top-container__paragraph__description__uOwCT","upgrade-top-container__accordion__heading":"UpgradeTopContainer_upgrade-top-container__accordion__heading__xaP4Q","upgrade-top-container__accordion__heading__image":"UpgradeTopContainer_upgrade-top-container__accordion__heading__image__nX4uB","otp-section":"UpgradeTopContainer_otp-section__dineA","upgrade-top-container__otp__number-input":"UpgradeTopContainer_upgrade-top-container__otp__number-input__lZR66","upgrade-top-container__otp__number-input__heading":"UpgradeTopContainer_upgrade-top-container__otp__number-input__heading__izlzT","upgrade-top-container__otp__number-input__heading__image":"UpgradeTopContainer_upgrade-top-container__otp__number-input__heading__image__v4nn7","upgrade-top-container__otp__what-to-expect":"UpgradeTopContainer_upgrade-top-container__otp__what-to-expect__nfjXF","offers-text":"UpgradeTopContainer_offers-text__Ut_0S","offers-text__icon":"UpgradeTopContainer_offers-text__icon__hoIhc","checkbox-label":"UpgradeTopContainer_checkbox-label__NPL8K","checkbox-span":"UpgradeTopContainer_checkbox-span__lVXaD","disabled":"UpgradeTopContainer_disabled__AJ9k_","cell-number":"UpgradeTopContainer_cell-number__cXQec","checkbox-container":"UpgradeTopContainer_checkbox-container__1CEIo","drop-down":"UpgradeTopContainer_drop-down__bQ6s6","drop-down-item":"UpgradeTopContainer_drop-down-item__l0vb5","back-btn":"UpgradeTopContainer_back-btn__3qc5B","default-heading":"UpgradeTopContainer_default-heading__2m6Fi","cell-phone":"UpgradeTopContainer_cell-phone__d16qI","error":"UpgradeTopContainer_error__Uvzbh","error-input":"UpgradeTopContainer_error-input__cOlNd","main-cta":"UpgradeTopContainer_main-cta__SftkI","offers-text__description":"UpgradeTopContainer_offers-text__description__N_0VW","input-label-container":"UpgradeTopContainer_input-label-container__L3Dai","previous-radio-label":"UpgradeTopContainer_previous-radio-label__qB12a","selected-num":"UpgradeTopContainer_selected-num__40pGX","cell-label":"UpgradeTopContainer_cell-label__JJEXC"};

/***/ }),

/***/ 65280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"PastUsage_accordion__vc_di","accordion__toggle":"PastUsage_accordion__toggle__d3Vgq","accordion__toggle--active":"PastUsage_accordion__toggle--active__Pz7JE","accordion__collapse":"PastUsage_accordion__collapse__Cd_wA","amount-border":"PastUsage_amount-border__SmTyR","accordion-title":"PastUsage_accordion-title__IXkeC","boxes":"PastUsage_boxes__MGw0D","data-des":"PastUsage_data-des__PYwAt","data-usage":"PastUsage_data-usage__7QhaX","OverSpend-div":"PastUsage_OverSpend-div__pS16N","OverSpend-div__title":"PastUsage_OverSpend-div__title__NcpE_","OverSpend-div__description":"PastUsage_OverSpend-div__description__8yTgK","OverSpend-div__description1":"PastUsage_OverSpend-div__description1__7wQ0Q","details-section-row":"PastUsage_details-section-row__aGSUC","details-label":"PastUsage_details-label__vfcoM","details-value":"PastUsage_details-value__RxxlO","details-deal-sub-section":"PastUsage_details-deal-sub-section__xcMaK","sub-section-mobile-styling":"PastUsage_sub-section-mobile-styling__Jo_td","section-divider":"PastUsage_section-divider__RIif9","contract-type":"PastUsage_contract-type__NsrW5","tab-content":"PastUsage_tab-content__N687t","box-container":"PastUsage_box-container__wcli9","error-message":"PastUsage_error-message__GiaD3","error-image":"PastUsage_error-image__28fOr","pastusage-content-boxes":"PastUsage_pastusage-content-boxes__CJyt7","error-warning":"PastUsage_error-warning__h_DEB","error-warning--des":"PastUsage_error-warning--des__GMdDC","error-icon":"PastUsage_error-icon__b9gMO","hide-block":"PastUsage_hide-block__0zsrN","go-back-btn":"PastUsage_go-back-btn__7NiCa","back-img":"PastUsage_back-img__ut6C0"};

/***/ }),

/***/ 38842:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"UpgradeCarousel_carousel-container__ylfNM","upgrade-carousel-container":"UpgradeCarousel_upgrade-carousel-container__ZE_wG","upgrade-slide":"UpgradeCarousel_upgrade-slide__BCtGh","prev-arrow":"UpgradeCarousel_prev-arrow__YEeRI","next-arrow":"UpgradeCarousel_next-arrow__IvDJC","mobile-accordion":"UpgradeCarousel_mobile-accordion__4X8NG","upgrade-online-heading":"UpgradeCarousel_upgrade-online-heading__7o06J","upgrade-accordion-symbol":"UpgradeCarousel_upgrade-accordion-symbol__jjocj","card-container":"UpgradeCarousel_card-container__p_zza"};

/***/ }),

/***/ 83667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cta-container":"UpgradeDealsGrid_cta-container__EoNcv","cta-list":"UpgradeDealsGrid_cta-list__t_D5a","cta-text":"UpgradeDealsGrid_cta-text__AwQ3y","cta-text__icon":"UpgradeDealsGrid_cta-text__icon__S4W8j","cta-heading":"UpgradeDealsGrid_cta-heading__sf97i","cta-description":"UpgradeDealsGrid_cta-description__VWoBB","cta-deals":"UpgradeDealsGrid_cta-deals__x2nvv","cta-products":"UpgradeDealsGrid_cta-products__U2o4j"};

/***/ }),

/***/ 24644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-benifits__row__col":"UpgradeBenifits_upgrade-benifits__row__col__VAq41","upgrade-benifits__row__col__img":"UpgradeBenifits_upgrade-benifits__row__col__img__YkG6q","card-title":"UpgradeBenifits_card-title__eOqK3","card-description":"UpgradeBenifits_card-description__aiTf9"};

/***/ }),

/***/ 48330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error-message":"UpgradeDealsPageContainer_error-message__W4wM9","heading-and-filter-button-wrapper":"UpgradeDealsPageContainer_heading-and-filter-button-wrapper__7Wie8","filters-modal-button":"UpgradeDealsPageContainer_filters-modal-button___LYuz","button-image":"UpgradeDealsPageContainer_button-image__RAOHL","button-label":"UpgradeDealsPageContainer_button-label__xfE5g","filter-image":"UpgradeDealsPageContainer_filter-image__d6xDI","error-image":"UpgradeDealsPageContainer_error-image__kuibd","just-heading":"UpgradeDealsPageContainer_just-heading__cc0Sb","benifits-container":"UpgradeDealsPageContainer_benifits-container__bz7Pa","filters-modal":"UpgradeDealsPageContainer_filters-modal__EKAfa","dse-container":"UpgradeDealsPageContainer_dse-container__0i9id","pastusage-container":"UpgradeDealsPageContainer_pastusage-container__MgLYz","button-container":"UpgradeDealsPageContainer_button-container__nTWE3"};

/***/ }),

/***/ 6115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-drop-down":"UpgradePageFilters_upgrade-drop-down__sGOpY","dropdown-text":"UpgradePageFilters_dropdown-text__dRhrs","dropdown-container":"UpgradePageFilters_dropdown-container__Ch6LF","hide-btn":"UpgradePageFilters_hide-btn__KhTPW","brands-modal":"UpgradePageFilters_brands-modal__Q2MT5","brands-modal-large-list":"UpgradePageFilters_brands-modal-large-list__G2C2O","disabled":"UpgradePageFilters_disabled__bqHaw","model-heading":"UpgradePageFilters_model-heading__ijFFv","model-options":"UpgradePageFilters_model-options__THK8Y","modal-apply":"UpgradePageFilters_modal-apply__OiHCT","just-heading":"UpgradePageFilters_just-heading___UABf","contract-heading":"UpgradePageFilters_contract-heading__IAZ_5","options":"UpgradePageFilters_options__GbfiC","option-text":"UpgradePageFilters_option-text__wU9NY","active-option":"UpgradePageFilters_active-option__LKSac","brand-label":"UpgradePageFilters_brand-label__Lnjw_","brand-radio":"UpgradePageFilters_brand-radio__H4Rom","error-message":"UpgradePageFilters_error-message__z5ePH","error-message-icon":"UpgradePageFilters_error-message-icon__HuPgG","clear-btn":"UpgradePageFilters_clear-btn__XJb4D","left-filters":"UpgradePageFilters_left-filters__F1frR","right-filter":"UpgradePageFilters_right-filter__zJ6MD","deals-btn":"UpgradePageFilters_deals-btn__fJrEu","brand-container":"UpgradePageFilters_brand-container__t59sE","disabled-modal":"UpgradePageFilters_disabled-modal__f3Uoo","white":"UpgradePageFilters_white___RTbT","disabled-clear":"UpgradePageFilters_disabled-clear__llIfX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1216,8005,4945,280,8294,9774,2888,179], function() { return __webpack_exec__(83059); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);